

// import React, { useState, useEffect ,} from "react";
// import "./NewPatientRegistration.css";

// const NewPatientRegistration = ({screenAction, triggerSave}) => {
//     const [isDisabled, setIsDisabled] = useState(true);
// const [searchText, setSearchText] = useState("");
// const [patients, setPatients] = useState([]);
// const [showDropdown, setShowDropdown] = useState(false);
// const [medicalFiles, setMedicalFiles] = useState([]);
// const [departments, setDepartments] = useState([]);
//   const [doctors, setDoctors] = useState([]);
// const initialFormState = {
// patient_id:"",
// name:"",
// gender:"",
// dob:"",
// age:"",
// blood_group:"",
// marital_status:"",

// mobile:"",
// email:"",
// address:"",
// city:"",
// state:"",
// pincode:"",

// govt_id_type:"",
// govt_id_number:"",

// emergency_name:"",
// emergency_relation:"",
// emergency_phone:"",

// allergies:"",
// conditions:"",
// medications:"",
// medical_history:"",
// medical_file:null,

// insurance_provider:"",
// policy_number:"",
// insurance_validity:"",

// department:"",
// doctor:"",
// appointment_date:"",
// visit_type:"",

// registration_date:"",
// registration_fee:"",
// referred_by:""
// };
// const [formData,setFormData] = useState(initialFormState);
// const user = JSON.parse(localStorage.getItem("user"));


// // const searchPatients = async (text) => {

// //   setSearchText(text);

// //   if(text.length < 2){
// //     setPatients([]);
// //     return;
// //   }

// //   const res = await fetch(`/api/patients/search?q=${text}`);
// //   const data = await res.json();

// //   setPatients(data);
// //   setShowDropdown(true);
// // };

// const searchPatients = async (text) => {

//   setSearchText(text);

//   if(text.length < 2){
//     setPatients([]);
//     return;
//   }

//   const user = JSON.parse(localStorage.getItem("user"));

//   const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patients/search?q=${text}&employee_id=${user.id}`);
//   const data = await res.json();

//   setPatients(data);
//   setShowDropdown(true);
// };


// // const selectPatient = (patient) => {
// //   // Helper to ensure YYYY-MM-DD
// //   const cleanDate = (d) => (d ? d.split("T")[0] : "");
  
// //   // Helper to ensure YYYY-MM-DDTHH:mm
// //   const cleanDateTime = (d) => {
// //     if (!d) return "";
// //     // Remove seconds and Z, replace space with T if necessary
// //     return d.replace(" ", "T").slice(0, 16);
// //   };

// //   setFormData({
// //     ...patient,
// //     dob: cleanDate(patient.dob),
// //     insurance_validity: cleanDate(patient.insurance_validity),
// //     registration_date: cleanDate(patient.registration_date),
// //     appointment_date: cleanDateTime(patient.appointment_date)
// //   });

// //   setSearchText(`${patient.name} | ${patient.patient_id} | ${patient.mobile}`);
// //   setShowDropdown(false);

// //   if (screenAction === "edit") setIsDisabled(false);
// //   if (screenAction === "view") setIsDisabled(true);
// // };


// const selectPatient = (patient) => {
//   const cleanDate = (d) => (d ? d.split("T")[0] : "");
//   const cleanDateTime = (d) => {
//     if (!d) return "";
//     return d.replace(" ", "T").slice(0, 16);
//   };

//   setFormData({
//     ...patient,
//     dob: cleanDate(patient.dob),
//     insurance_validity: cleanDate(patient.insurance_validity),
//     registration_date: cleanDate(patient.registration_date),
//     appointment_date: cleanDateTime(patient.appointment_date),
//   });

//   // ✅ 1. Identify the file source (check both singular and plural keys)
//   const rawFiles = patient.medical_files || patient.medical_file;

//   if (rawFiles) {
//     try {
//       // ✅ 2. Parse if it's a string, otherwise use as is
//       const fileList = typeof rawFiles === "string" ? JSON.parse(rawFiles) : rawFiles;

//       if (Array.isArray(fileList)) {
//         const existingFiles = fileList.map((fileName) => ({
//           file: null, 
//           // ✅ 3. Ensure this URL matches your backend upload folder exactly
//           preview: `${fileName}`, 
//           isExisting: true,
//           fileName: fileName 
//         }));
//         setMedicalFiles(existingFiles);
//       }
//     } catch (e) {
//       console.error("Error parsing medical files:", e);
//       // Fallback if it's just a single string and not a JSON array
//       if (typeof rawFiles === "string" && rawFiles.length > 4) {
//         setMedicalFiles([{
//           file: null,
//           preview: `${rawFiles}`,
//           isExisting: true,
//           fileName: rawFiles
//         }]);
//       }
//     }
//   } else {
//     setMedicalFiles([]);
//   }

//   setSearchText(`${patient.name} | ${patient.patient_id} | ${patient.mobile}`);
//   setShowDropdown(false);
//   if (screenAction === "edit") setIsDisabled(false);
//   if (screenAction === "view") setIsDisabled(true);
// };


// // Gets current local date & time in YYYY-MM-DDThh:mm format
//   const getCurrentLocalDateTime = () => {
//     const now = new Date();
//     now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
//     return now.toISOString().slice(0, 16);
//   };

// const clearForm = () => {

//  const date = new Date();
//  const newId = `EM-${date.getFullYear()}-${Math.floor(1000+Math.random()*9000)}`;

//  setFormData({
//    ...initialFormState,
//    patient_id:newId,
//    registration_date:new Date().toISOString().split("T")[0]
//  });

// setSearchText(""); // Clear the search bar too
//   setIsDisabled(false);
//   console.log("Form Cleared");

// };
// // When Department Changes: Update state and clear the previously selected doctor
//   const handleDepartmentChange = (e) => {
//     const val = e.target.value;
//     setFormData(prev => ({ ...prev, department: val, doctor: "", registration_fee: "" }));
//   };

//   // When Doctor Changes: Auto-fill the registration fee based on the selected doctor
// // When Doctor Changes: Auto-fill the registration fee based on the selected doctor
//   const handleDoctorChange = (e) => {
//     const docName = e.target.value;
    
//     // Find the full doctor object (using trim to avoid space issues)
//     const selectedDoc = doctors.find(d => d.doctor_name.trim() === docName.trim());
    
//     setFormData(prev => ({ 
//       ...prev, 
//       doctor: docName, 
//       // Ensure we format the fee to 2 decimal places if it exists
//       registration_fee: selectedDoc ? parseFloat(selectedDoc.consultation_fee).toFixed(2) : "" 
//     }));
//   };

// // 1. INITIAL LOAD: Fetch Departments
// useEffect(() => {
//   const fetchDepartments = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!user?.id) return;

//     try {
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments?employee_id=${user.id}`);
//       const deptData = await res.json();

//       // Support both array or { success, data } response
//       const depts = Array.isArray(deptData)
//         ? deptData
//         : Array.isArray(deptData.data)
//         ? deptData.data
//         : [];
//       setDepartments(depts);
//     } catch (err) {
//       console.error("Error loading departments", err);
//     }
//   };
//   fetchDepartments();
// }, []);

// // 2. DYNAMIC LOAD: Fetch Doctors whenever Department changes

// useEffect(() => {
//   const fetchDoctorsByDept = async () => {
//     if (!formData.department) {
//       setDoctors([]); 
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!user?.id) return;

//     try {
//       // NOTE: Ensure this URL matches your actual backend EXACTLY!
//       const res = await fetch(
//         `https://hmsapi.emedhatechnologies.com/master/api/api/doctorss?employee_id=${user.id}&department=${encodeURIComponent(formData.department)}`
//       );
//       const docData = await res.json();

//       const doctorsList = Array.isArray(docData)
//         ? docData
//         : Array.isArray(docData.data)
//         ? docData.data
//         : [];
//       setDoctors(doctorsList);
//     } catch (err) {
//       console.error("Error loading doctors", err);
//       setDoctors([]); 
//     }
//   };

//   fetchDoctorsByDept();
// }, [formData.department]);

// const enableEditing = () => {
//   setIsDisabled(false);
// };

// const loadPatientById = async(id) => {

//  const res = await fetch(`/api/patient/${id}`);
//  const data = await res.json();

//  setFormData(data);
//  setIsDisabled(false);

// };

// const loadPatientData = () => {
//   console.log("Reload patient data");
// };

// const viewPatient = async(id)=>{

//  const res = await fetch(`/api/patient/${id}`);
//  const data = await res.json();

//  setFormData(data);
//  setIsDisabled(true);

// };

// const disableEditing = () => {
//   setIsDisabled(true);
// };

// const refreshForm = () => {
//   // Only try to load from API if the patient actually exists (has a 'created_at' timestamp)
//   if (formData.created_at) {
//     loadPatientById(formData.patient_id);
//   } else {
//     // If it's a new unsaved form, just clear it
//     clearForm();
//   }
// };


// useEffect(()=>{

// const date = new Date();
// const id = `EM-${date.getFullYear()}-${Math.floor(1000+Math.random()*9000)}`;

// setFormData(prev=>({
// ...prev,
// patient_id:id,
// registration_date:new Date().toISOString().split("T")[0]
// }));

// },[]);

// const handleChange = (e)=>{

// const {name,value,files} = e.target;

// if(files){
// setFormData({...formData,[name]:files[0]});
// }else{
// setFormData({...formData,[name]:value});
// }

// };

// const handleFileChange = (e) => {
//   const files = Array.from(e.target.files);

//   const filesWithPreview = files.map(file => ({
//     file,
//     preview: URL.createObjectURL(file)
//   }));

//   setMedicalFiles(prev => [...prev, ...filesWithPreview]);
// };

// const removeFile = (index) => {
//   const updated = [...medicalFiles];
//   updated.splice(index, 1);
//   setMedicalFiles(updated);
// };

// useEffect(() => {

//   if(screenAction === "add"){
//     clearForm();
//   }

//   if(screenAction === "edit"){
//     enableEditing();
//   }

//   if(screenAction === "view"){
//     disableEditing();
//   }

//   // if(screenAction === "save"){
//   //   handleSubmit();
//   // }

//   if(screenAction === "refresh"){
//     refreshForm();
//   }

//   if(screenAction === "print"){
//     printForm();
//   }

// }, [screenAction]);

// // This effect handles the click from the Dashboard Topbar
// useEffect(() => {
//   if (triggerSave > 0 && screenAction === "save") {
//     handleSubmit();
//   }
// }, [triggerSave]);

// // const handleSubmit = async () => {

// // if(screenAction === "add"){

// //  await fetch("/api/patient",{
// //   method:"POST",
// //   headers:{'Content-Type':'application/json'},
// //   body:JSON.stringify(formData)
// //  });

// // }

// // if(screenAction === "edit"){

// //  await fetch(`/api/patient/${formData.patient_id}`,{
// //   method:"PUT",
// //   headers:{'Content-Type':'application/json'},
// //   body:JSON.stringify(formData)
// //  });

// // }

// // alert("Patient Saved");

// // };


// const formatDate = (date) => {
//   if (!date) return null;
//   return date.split("T")[0]; // ✅ YYYY-MM-DD
// };




// // const handleSubmit = async () => {
// //   const user = JSON.parse(localStorage.getItem("user"));
  
// //   if (!formData.name) {
// //     alert("Please enter patient name");
// //     return;
// //   }

// //   // Create a clean payload
// //   const payload = { ...formData };

// //   // 1. DELETE database-managed timestamps so they don't break MySQL
// //   delete payload.created_at;
// //   delete payload.updated_at;

// //   // 2. Add user ID
// //   payload.created_by = user.id;

// //   // 3. Fix Date Fields for MySQL (YYYY-MM-DD)
// //   payload.dob = formatDate(formData.dob);
// //   payload.insurance_validity = formatDate(formData.insurance_validity);
// //   payload.registration_date = formatDate(formData.registration_date);

// //   // 4. Fix Appointment Date for MySQL (YYYY-MM-DD HH:mm:ss)
// //   if (payload.appointment_date) {
// //     // Replace the 'T' with a space and remove the seconds if present
// //     payload.appointment_date = payload.appointment_date.replace("T", " ").split(".")[0];
// //   }

// //   console.log("CLEAN PAYLOAD:", payload);

// //   const method = formData.created_at || formData.hospital_id ? "PUT" : "POST";
// //   const url = method === "POST"
// //     ? "https://hmsapi.emedhatechnologies.com/master/api/api/patient"
// //     : `https://hmsapi.emedhatechnologies.com/master/api/api/patient/${formData.patient_id}`;

// //   try {
// //     const res = await fetch(url, {
// //       method,
// //       headers: { 'Content-Type': 'application/json' },
// //       body: JSON.stringify(payload)
// //     });

// //     if (res.ok) {
// //       alert("Patient Saved Successfully!");
// //       if (method === "POST") clearForm();
// //     } else {
// //       const errorData = await res.json();
// //       alert("Error: " + (errorData.message || "Failed to save"));
// //     }
// //   } catch (error) {
// //     console.error("Fetch Error:", error);
// //     alert("Network Error");
// //   }
// // };

// const handleSubmit = async () => {
//   const user = JSON.parse(localStorage.getItem("user"));

//   if (!formData.name) {
//     alert("Please enter patient name");
//     return;
//   }

//   const formDataObj = new FormData();

//   // ✅ Clone and clean payload
//   const payload = { ...formData };

//   delete payload.created_at;
//   delete payload.updated_at;

//   payload.created_by = user.id;

//   // ✅ Fix Dates
//   payload.dob = formatDate(formData.dob);
//   payload.insurance_validity = formatDate(formData.insurance_validity);
//   payload.registration_date = formatDate(formData.registration_date);

//   if (payload.appointment_date) {
//     payload.appointment_date = payload.appointment_date
//       .replace("T", " ")
//       .split(".")[0];
//   }

//   // ✅ Append all normal fields
//   Object.keys(payload).forEach((key) => {
//     formDataObj.append(key, payload[key] || "");
//   });

//   // ✅ Separate New Files from Existing Files
//   const existingFileNames = medicalFiles
//     .filter(item => item.isExisting)
//     .map(item => item.fileName);
  
//   // Send the list of existing files to keep
//   formDataObj.append("existing_files", JSON.stringify(existingFileNames));

//   // Send the actual new File objects
//   medicalFiles.forEach((item) => {
//     if (!item.isExisting) {
//       formDataObj.append("medical_files", item.file);
//     }
//   });

//   console.log("FORM DATA READY");

//   const method = formData.created_at || formData.hospital_id ? "PUT" : "POST";

//   const url =
//     method === "POST"
//       ? "https://hmsapi.emedhatechnologies.com/master/api/api/patient"
//       : `https://hmsapi.emedhatechnologies.com/master/api/api/patient/${formData.patient_id}`;

//   try {
//     const res = await fetch(url, {
//       method,
//       body: formDataObj, // ❗ NO headers here
//     });

//     if (res.ok) {
//       alert("Patient Saved Successfully!");
//       if (method === "POST") {
//         clearForm();
//         setMedicalFiles([]); // ✅ clear previews
//       }
//     } else {
//       const errorData = await res.json();
//       alert("Error: " + (errorData.message || "Failed to save"));
//     }
//   } catch (error) {
//     console.error("Fetch Error:", error);
//     alert("Network Error");
//   }
// };

// const printForm = () => {
//   const newWindow = window.open("", "", "width=900,height=700");

//   // Get current date for the footer/header
//   const today = new Date().toLocaleDateString();

//   const htmlContent = `
//     <html>
//       <head>
//         <title>Patient Registration - ${formData.name || 'New Patient'}</title>
//         <style>
//           body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
          
//           /* Header Section */
//           .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2c3e50; padding-bottom: 10px; margin-bottom: 20px; }
//           .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
//           .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
//           .report-title { text-align: right; }
//           .report-title h2 { margin: 0; color: #e74c3c; font-size: 18px; }
          
//           /* Section Styling */
//           .section-header { background: #f2f4f4; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2c3e50; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
          
//           /* Data Grid */
//           .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
//           .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 4px 0; }
//           .label { font-weight: 600; width: 150px; color: #555; }
//           .value { flex: 1; color: #000; }
//           .full-width { grid-column: span 2; }

//           /* Footer */
//           .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
//           .sig-box { margin-top: 40px; display: flex; justify-content: space-between; }
//           .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

//           @media print {
//             button { display: none; }
//             body { padding: 20px; }
//           }
//         </style>
//       </head>
//       <body>
//         <div class="header">
//           <div class="hospital-info">
//             <h1>EMEDHA CARE HOSPITAL</h1>
//             <p>123 Medical Park, Health City - 560001</p>
//             <p>Phone: +91 98765 43210 | Email: contact@citycare.com</p>
//           </div>
//           <div class="report-title">
//             <h2>PATIENT REGISTRATION</h2>
//             <p>Date: ${today}</p>
//           </div>
//         </div>

//         <div class="section-header">Basic Patient Details</div>
//         <div class="data-grid">
//           <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id || 'N/A'}</span></div>
//           <div class="data-item"><span class="label">Full Name:</span> <span class="value">${formData.name || ''}</span></div>
//           <div class="data-item"><span class="label">Gender:</span> <span class="value">${formData.gender || ''}</span></div>
//           <div class="data-item"><span class="label">Age / DOB:</span> <span class="value">${formData.age || ''} Yrs / ${formData.dob || ''}</span></div>
//           <div class="data-item"><span class="label">Blood Group:</span> <span class="value">${formData.blood_group || ''}</span></div>
//           <div class="data-item"><span class="label">Marital Status:</span> <span class="value">${formData.marital_status || ''}</span></div>
//         </div>

//         <div class="section-header">Contact & Identification</div>
//         <div class="data-grid">
//           <div class="data-item"><span class="label">Mobile:</span> <span class="value">${formData.mobile || ''}</span></div>
//           <div class="data-item"><span class="label">Email:</span> <span class="value">${formData.email || ''}</span></div>
//           <div class="data-item full-width"><span class="label">Address:</span> <span class="value">${formData.address || ''}, ${formData.city || ''}, ${formData.state || ''} - ${formData.pincode || ''}</span></div>
//           <div class="data-item"><span class="label">${formData.govt_id_type || 'ID'}:</span> <span class="value">${formData.govt_id_number || ''}</span></div>
//         </div>

//         <div class="section-header">Appointment & Medical Details</div>
//         <div class="data-grid">
//           <div class="data-item"><span class="label">Department:</span> <span class="value">${formData.department || ''}</span></div>
//           <div class="data-item"><span class="label">Consultant:</span> <span class="value">Dr. ${formData.doctor || ''}</span></div>
//           <div class="data-item"><span class="label">Appt Date:</span> <span class="value">${formData.appointment_date || ''}</span></div>
//           <div class="data-item"><span class="label">Visit Type:</span> <span class="value">${formData.visit_type || ''}</span></div>
//           <div class="data-item full-width"><span class="label">Allergies:</span> <span class="value">${formData.allergies || 'None'}</span></div>
//         </div>

//         <div class="sig-box">
//           <div class="sig">Patient/Guardian Signature</div>
//           <div class="sig">Authorized Signatory</div>
//         </div>

//         <div class="footer">
//           This is a computer-generated registration form and does not require a physical stamp for internal use.
//         </div>
//       </body>
//     </html>
//   `;

//   newWindow.document.write(htmlContent);
//   newWindow.document.close();
  
//   // Give a small timeout for styles to load before printing
//   setTimeout(() => {
//     newWindow.print();
//     newWindow.close();
//   }, 500);
// };




// return(

// <div className="registration-container fade-in" id="print-area">
// {(screenAction === "edit" || screenAction === "view") && (

// <div className="patient-search">

// <label>Search Patient</label>

// <input
//   type="text"
//   value={searchText}
//   placeholder="Search by Name / ID / Mobile"
//   onChange={(e)=>searchPatients(e.target.value)}
// />

// {showDropdown && patients.length > 0 && (

// <div className="patient-dropdown">

// {patients.map((p)=>(
// <div
//  key={p.patient_id}
//  className="patient-item"
//  onClick={()=>selectPatient(p)}
// >

// {p.name} | {p.patient_id} | {p.mobile}

// </div>
// ))}

// </div>

// )}

// </div>

// )}

// {screenAction === "view" && formData.patient_id && (
//     <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px'  , marginTop: '10px'}}>
//             <button 
//               type="button"
//               onClick={() => alert(`Share Patient details (${formData.patient_id}) via WhatsApp!`)}
//               style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#25D366', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(37, 211, 102, 0.3)', height: '36px' }}
//               title="Share via WhatsApp"
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
//                 <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
//               </svg>
//               WhatsApp
//             </button>
//                  </div>
//           )}
     

// <form className="luxury-form" >

// {/* BASIC DETAILS */}

// {/* BASIC DETAILS */}
// <div className="form-section-header">
//   <h3>Basic Patient Details</h3>
// </div>

// {/* ROW 1: Patient ID, Full Name, Gender, DOB, Age (All in one line on large screens) */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>
  
//   <div className="input-box read-only" style={{ flex: '1 1 120px' }}>
//     <label>Patient ID</label>
//     <input type="text" name="patient_id" value={formData.patient_id || ""} readOnly/>
//   </div>

//   <div className="input-box" style={{ flex: '2 1 200px' }}>
//     <label>Full Name</label>
//     <input type="text" name="name" onChange={handleChange} required value={formData.name || ""} disabled={isDisabled} />
//   </div>

//   <div className="input-box" style={{ flex: '0.8 1 100px' }}>
//     <label>Gender</label>
//     <select name="gender" onChange={handleChange} required value={formData.gender || ""} disabled={isDisabled}>
//       <option value="">Select</option>
//       <option>Male</option>
//       <option>Female</option>
//       <option>Other</option>
//     </select>
//   </div>

//   <div className="input-box" style={{ flex: '1 1 130px' }}>
//     <label>Date of Birth</label>
//     <input type="date" name="dob" onChange={handleChange} value={formData.dob || ""} disabled={isDisabled} />
//   </div>

//   <div className="input-box" style={{ flex: '0.5 1 70px' }}>
//     <label>Age</label>
//     <input type="number" name="age" onChange={handleChange} value={formData.age || ""} disabled={isDisabled}/>
//   </div>

// </div>

// {/* ROW 2: Blood Group & Marital Status (Reduced widths) */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>
  
//   {/* Changed flex-grow to 0, and base width to 150px */}
//   <div className="input-box" style={{ flex: '0 1 150px' }}>
//     <label>Blood Group</label>
//     <select name="blood_group" onChange={handleChange} value={formData.blood_group || ""} disabled={isDisabled}> 
//       <option value="">Select</option>
//       <option>A+</option>
//       <option>B+</option>
//       <option>O+</option>
//       <option>AB+</option>
//       <option>A-</option>
//       <option>B-</option>
//       <option>O-</option>
//       <option>AB-</option>
//     </select>
//   </div>

//   {/* Changed flex-grow to 0, and base width to 150px */}
//   <div className="input-box" style={{ flex: '0 1 150px' }}>
//     <label>Marital Status</label>
//     <select name="marital_status" onChange={handleChange} value={formData.marital_status || ""} disabled={isDisabled}>
//       <option value="">Select</option>
//       <option>Single</option>
//       <option>Married</option>
//       <option>Divorced</option>
//     </select>
//   </div>

// </div>

// {/* CONTACT INFORMATION */}

// {/* CONTACT INFORMATION */}
// <div className="form-section-header">
//   <h3>Contact Information</h3>
// </div>

// {/* ROW 1: Mobile, WhatsApp, OTP, Email */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px', alignItems: 'flex-end' }}>
  
//   <div className="input-box" style={{ flex: '1.5 1 180px' }}>
//     <label>Mobile Number</label>
//     <input type="tel" name="mobile" onChange={handleChange} value={formData.mobile || ""} disabled={isDisabled} />
//   </div>

//   {/* WhatsApp Checkbox (Compact) */}
//   <div className="input-box" style={{ flex: '0 1 100px', display: 'flex', alignItems: 'center', height: '42px', paddingBottom: '5px' }}>
//     <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0, fontWeight: 'bold', fontSize: '13px' }}>
//       <input type="checkbox" name="whatsapp_yn" disabled={isDisabled} style={{ width: '16px', height: '16px', margin: 0 }} /> WhatsApp?
//     </label>
//   </div>

//   <div className="input-box" style={{ flex: '1 1 120px' }}>
//     <label>OTP</label>
//     <input type="text" name="otp" placeholder="Enter OTP" disabled={isDisabled} />
//   </div>

//   <div className="input-box" style={{ flex: '2 1 250px' }}>
//     <label>Email</label>
//     <input type="email" name="email" onChange={handleChange} value={formData.email || ""} disabled={isDisabled} />
//   </div>

// </div>

// {/* ROW 2: Address, City, State, Pin Code */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
  
//   {/* Address takes up the most space (flex: 3), height reduced to match inputs */}
//   <div className="input-box" style={{ flex: '3 1 250px' }}>
//     <label>Address</label>
//     <textarea 
//       name="address" 
//       onChange={handleChange} 
//       value={formData.address || ""} 
//       disabled={isDisabled} 
//       rows="1" 
//       style={{ height: '42px', minHeight: '42px', padding: '10px' }} 
//     />
//   </div>

//   <div className="input-box" style={{ flex: '1 1 120px' }}>
//     <label>City</label>
//     <input type="text" name="city" onChange={handleChange} value={formData.city || ""} disabled={isDisabled} />
//   </div>

//   <div className="input-box" style={{ flex: '1 1 120px' }}>
//     <label>State</label>
//     {/* Default value set to Telangana if empty */}
//     <input type="text" name="state" onChange={handleChange} value={formData.state || "Telangana"} disabled={isDisabled} />
//   </div>

//   <div className="input-box" style={{ flex: '1 1 100px' }}>
//     <label>Pin Code</label>
//     <input type="text" name="pincode" onChange={handleChange} value={formData.pincode || ""} disabled={isDisabled} />
//   </div>

// </div>

// {/* IDENTIFICATION */}

// {/* IDENTIFICATION & EMERGENCY CONTACT */}
// <div className="form-section-header">
//   <h3>Identification & Emergency Contact</h3>
// </div>

// {/* ROW: Govt ID, ID Number, Contact Name, Relationship, Emergency Phone */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>
  
//   <div className="input-box" style={{ flex: '1 1 130px' }}>
//     <label>Government ID</label>
//     <select name="govt_id_type" onChange={handleChange} value={formData.govt_id_type || ""} disabled={isDisabled}>
//       <option value="">Select</option>
//       <option>Aadhaar</option>
//       <option>Passport</option>
//       <option>Driving License</option>
//     </select>
//   </div>

//   <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//     <label>ID Number</label>
//     <input type="text" name="govt_id_number" onChange={handleChange} value={formData.govt_id_number || ""} disabled={isDisabled}/>
//   </div>

//   <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//     <label>Contact Name</label>
//     <input type="text" name="emergency_name" onChange={handleChange} value={formData.emergency_name || ""} disabled={isDisabled}/>
//   </div>

//   <div className="input-box" style={{ flex: '1 1 120px' }}>
//     <label>Relationship</label>
//     <input type="text" name="emergency_relation" onChange={handleChange} value={formData.emergency_relation || ""} disabled={isDisabled}/>
//   </div>

//   <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//     <label>Emergency Phone</label>
//     <input type="tel" name="emergency_phone" onChange={handleChange} value={formData.emergency_phone || ""} disabled={isDisabled}/>
//   </div>

// </div>


// {/* MEDICAL */}

// {/* MEDICAL INFORMATION */}
// <div className="form-section-header">
//   <h3>Medical Information</h3>
// </div>

// {/* ROW 1: All 4 Medical fields on one line */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>
  
//   <div className="input-box" style={{ flex: '1 1 180px' }}>
//     <label>Known Allergies</label>
//     <textarea 
//       name="allergies" 
//       onChange={handleChange} 
//       value={formData.allergies || ""} 
//       disabled={isDisabled} 
//       rows="2" 
//       style={{ overflowY: 'auto', resize: 'vertical' }}
//     />
//   </div>

//   <div className="input-box" style={{ flex: '1 1 180px' }}>
//     <label>Existing Conditions</label>
//     <textarea 
//       name="conditions" 
//       onChange={handleChange} 
//       value={formData.conditions || ""} 
//       disabled={isDisabled} 
//       rows="2" 
//       style={{ overflowY: 'auto', resize: 'vertical' }}
//     />
//   </div>

//   <div className="input-box" style={{ flex: '1 1 180px' }}>
//     <label>Current Medications</label>
//     <textarea 
//       name="medications" 
//       onChange={handleChange} 
//       value={formData.medications || ""} 
//       disabled={isDisabled} 
//       rows="2" 
//       style={{ overflowY: 'auto', resize: 'vertical' }}
//     />
//   </div>

//   <div className="input-box" style={{ flex: '1 1 180px' }}>
//     <label>Previous Medical History</label>
//     <textarea 
//       name="medical_history" 
//       onChange={handleChange} 
//       value={formData.medical_history || ""} 
//       disabled={isDisabled} 
//       rows="2" 
//       style={{ overflowY: 'auto', resize: 'vertical' }}
//     />
//   </div>

// </div>

// {/* ROW 2: File Upload */}
// {/* ROW 2: File Upload (Reduced Width) */}
// <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>
  
//   {/* Changed flex to 0 1 300px so it only takes up necessary space */}
//   <div className="input-box" style={{ flex: '0 1 280px' }}>
//     <label>Upload Medical Records</label>
//     <input
//       type="file"
//       name="medical_file"
//       multiple
//       onChange={handleFileChange}
//       disabled={isDisabled}
//     />
//   </div>

// </div>

// {/* PREVIEW CONTAINER */}
// <div className="preview-container">
//   {Array.isArray(medicalFiles) && medicalFiles.length > 0 ? (
//     medicalFiles.map((item, index) => (
//       <div key={index} className="preview-box">
//         <img 
//           src={item.preview} 
//           alt="medical record" 
//           onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=File+Error'; }} 
//         />
//         {!isDisabled && (
//           <button 
//             type="button" 
//             className="remove-btn" 
//             onClick={() => removeFile(index)}
//           >
//             ✕
//           </button>
//         )}
//       </div>
//     ))
//   ) : (
//     <p style={{ fontSize: '12px', color: '#999', marginLeft: '10px' }}>No records uploaded.</p>
//   )}
// </div>

// {/* INSURANCE */}

// <div className="form-section-header">
// <h3>Insurance Details</h3>
// </div>

// <div className="form-grid">

// <div className="input-box">
// <label>Insurance Provider</label>
// <input type="text" name="insurance_provider" onChange={handleChange}  value={formData.insurance_provider || ""}  disabled={isDisabled}/>
// </div>

// <div className="input-box">
// <label>Policy Number</label>
// <input type="text" name="policy_number" onChange={handleChange} value={formData.policy_number || ""}   disabled={isDisabled}/>
// </div>

// <div className="input-box">
// <label>Insurance Validity</label>
// <input type="date" name="insurance_validity" onChange={handleChange} value={formData.insurance_validity || ""}   disabled={isDisabled}/>
// </div>

// </div>


// {/* APPOINTMENT */}

// <div className="form-section-header">
// <h3>Appointment Details</h3>
// </div>

// <div className="form-grid">

// <div className="input-box">
//     <label>Department</label>
//     <select name="department" onChange={handleDepartmentChange} value={formData.department || ""} disabled={isDisabled}>
//       <option value="">Select Department</option>
//       {departments.filter(d => d.status === 'Active').map(d => (
//         <option key={d.dept_cd} value={d.dept_name.trim()}>{d.dept_name.trim()}</option>
//       ))}
//     </select>
//   </div>

//   <div className="input-box">
//     <label>Doctor Name</label>
//     <select name="doctor" onChange={handleDoctorChange} value={formData.doctor || ""} disabled={isDisabled || !formData.department}>
//       <option value="">Select Doctor</option>
//       {/* 1. No .filter() needed here because the API already filtered by department.
//         2. Use .trim() to strip trailing spaces from "Dr. Ravi Kumar " 
//       */}
//       {doctors.map(d => (
//         <option key={d.doc_cd} value={d.doctor_name.trim()}>{d.doctor_name.trim()}</option>
//       ))}
//     </select>
//   </div>

// <div className="input-box">
// <label>Appointment Date</label>
// <input type="datetime-local" name="appointment_date" onChange={handleChange} min={getCurrentLocalDateTime()} value={formData.appointment_date || ""}   disabled={isDisabled}/>
// </div>

// <div className="input-box">
// <label>Visit Type</label>
// <select name="visit_type" onChange={handleChange} value={formData.visit_type || ""}   disabled={isDisabled}>
// <option>New</option>
// <option>Follow-up</option>
// <option>Emergency</option>
// </select>
// </div>

// </div>


// {/* ADMIN */}

// <div className="form-section-header">
// <h3>Administrative Details</h3>
// </div>

// <div className="form-grid">

// <div className="input-box">
// <label>Registration Date</label>
// <input type="date" name="registration_date" value={formData.registration_date || ""}   disabled={isDisabled}/>
// </div>

// <div className="input-box">
//     <label>Registration Fee (Editable)</label>
//     <input 
//       type="number" 
//       name="registration_fee" 
//       onChange={handleChange} 
//       value={formData.registration_fee || ""} 
//       disabled={isDisabled}
//       placeholder="Auto-fills from Doctor"
//     />
//   </div>
// <div className="input-box">
// <label>Referred By</label>
// <input type="text" name="referred_by" onChange={handleChange} value={formData.referred_by || ""}   disabled={isDisabled}/>
// </div>

// </div>

 
// </form>
// </div>
// );
// };

// export default NewPatientRegistration;


// import React, { useState, useEffect, } from "react";
// import "./NewPatientRegistration.css";
// import axios from "axios";

// const NewPatientRegistration = ({ screenAction, triggerSave }) => {
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [patients, setPatients] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [medicalFiles, setMedicalFiles] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [doctors, setDoctors] = useState([]);
//   const initialFormState = {
//     patient_id: "",
//     name: "",
//     gender: "",
//     dob: "",
//     age: "",
//     blood_group: "",
//     marital_status: "",

//     mobile: "",
//     email: "",
//     address: "",
//     city: "",
//     state: "",
//     pincode: "",

//     govt_id_type: "",
//     govt_id_number: "",

//     emergency_name: "",
//     emergency_relation: "",
//     emergency_phone: "",

//     allergies: "",
//     conditions: "",
//     medications: "",
//     medical_history: "",
//     medical_file: null,

//     insurance_provider: "",
//     policy_number: "",
//     insurance_validity: "",

//     department: "",
//     doctor: "",
//     appointment_date: "",
//     visit_type: "",

//     registration_date: "",
//     registration_fee: "",
//     referred_by: ""
//   };
//   const [formData, setFormData] = useState(initialFormState);
//   const user = JSON.parse(localStorage.getItem("user"));


//   // const searchPatients = async (text) => {

//   //   setSearchText(text);

//   //   if(text.length < 2){
//   //     setPatients([]);
//   //     return;
//   //   }

//   //   const res = await fetch(`/api/patients/search?q=${text}`);
//   //   const data = await res.json();

//   //   setPatients(data);
//   //   setShowDropdown(true);
//   // };

//   const searchPatients = async (text) => {

//     setSearchText(text);

//     if (text.length < 2) {
//       setPatients([]);
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem("user"));

//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patients/search?q=${text}&employee_id=${user.id}`);
//     const data = await res.json();

//     setPatients(data);
//     setShowDropdown(true);
//   };


//   // const selectPatient = (patient) => {
//   //   // Helper to ensure YYYY-MM-DD
//   //   const cleanDate = (d) => (d ? d.split("T")[0] : "");

//   //   // Helper to ensure YYYY-MM-DDTHH:mm
//   //   const cleanDateTime = (d) => {
//   //     if (!d) return "";
//   //     // Remove seconds and Z, replace space with T if necessary
//   //     return d.replace(" ", "T").slice(0, 16);
//   //   };

//   //   setFormData({
//   //     ...patient,
//   //     dob: cleanDate(patient.dob),
//   //     insurance_validity: cleanDate(patient.insurance_validity),
//   //     registration_date: cleanDate(patient.registration_date),
//   //     appointment_date: cleanDateTime(patient.appointment_date)
//   //   });

//   //   setSearchText(`${patient.name} | ${patient.patient_id} | ${patient.mobile}`);
//   //   setShowDropdown(false);

//   //   if (screenAction === "edit") setIsDisabled(false);
//   //   if (screenAction === "view") setIsDisabled(true);
//   // };


//   const selectPatient = (patient) => {
//     const cleanDate = (d) => (d ? d.split("T")[0] : "");
//     const cleanDateTime = (d) => {
//       if (!d) return "";
//       return d.replace(" ", "T").slice(0, 16);
//     };

//     setFormData({
//       ...patient,
//       dob: cleanDate(patient.dob),
//       insurance_validity: cleanDate(patient.insurance_validity),
//       registration_date: cleanDate(patient.registration_date),
//       appointment_date: cleanDateTime(patient.appointment_date),
//     });

//     // ✅ 1. Identify the file source (check both singular and plural keys)
//     const rawFiles = patient.medical_files || patient.medical_file;

//     if (rawFiles) {
//       try {
//         // ✅ 2. Parse if it's a string, otherwise use as is
//         const fileList = typeof rawFiles === "string" ? JSON.parse(rawFiles) : rawFiles;

//         if (Array.isArray(fileList)) {
//           const existingFiles = fileList.map((fileName) => ({
//             file: null,
//             // ✅ 3. Ensure this URL matches your backend upload folder exactly
//             preview: `${fileName}`,
//             isExisting: true,
//             fileName: fileName
//           }));
//           setMedicalFiles(existingFiles);
//         }
//       } catch (e) {
//         console.error("Error parsing medical files:", e);
//         // Fallback if it's just a single string and not a JSON array
//         if (typeof rawFiles === "string" && rawFiles.length > 4) {
//           setMedicalFiles([{
//             file: null,
//             preview: `${rawFiles}`,
//             isExisting: true,
//             fileName: rawFiles
//           }]);
//         }
//       }
//     } else {
//       setMedicalFiles([]);
//     }

//     setSearchText(`${patient.name} | ${patient.patient_id} | ${patient.mobile}`);
//     setShowDropdown(false);
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//   };


//   // Gets current local date & time in YYYY-MM-DDThh:mm format
//   const getCurrentLocalDateTime = () => {
//     const now = new Date();
//     now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
//     return now.toISOString().slice(0, 16);
//   };

//   const clearForm = () => {

//     const date = new Date();
//     const newId = `EM-${date.getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

//     setFormData({
//       ...initialFormState,
//       patient_id: newId,
//       registration_date: new Date().toISOString().split("T")[0]
//     });

//     setSearchText(""); // Clear the search bar too
//     setIsDisabled(false);
//     console.log("Form Cleared");

//   };
//   // When Department Changes: Update state and clear the previously selected doctor
//   const handleDepartmentChange = (e) => {
//     const val = e.target.value;
//     setFormData(prev => ({ ...prev, department: val, doctor: "", registration_fee: "" }));
//   };

//   // When Doctor Changes: Auto-fill the registration fee based on the selected doctor
//   // When Doctor Changes: Auto-fill the registration fee based on the selected doctor
//   const handleDoctorChange = (e) => {
//     const docName = e.target.value;

//     // Find the full doctor object (using trim to avoid space issues)
//     const selectedDoc = doctors.find(d => d.doctor_name.trim() === docName.trim());

//     setFormData(prev => ({
//       ...prev,
//       doctor: docName,
//       // Ensure we format the fee to 2 decimal places if it exists
//       registration_fee: selectedDoc ? parseFloat(selectedDoc.consultation_fee).toFixed(2) : ""
//     }));
//   };

//   // 1. INITIAL LOAD: Fetch Departments
//   useEffect(() => {
//     const fetchDepartments = async () => {
//       const user = JSON.parse(localStorage.getItem("user"));
//       if (!user?.id) return;

//       try {
//         const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments?employee_id=${user.id}`);
//         const deptData = await res.json();

//         // Support both array or { success, data } response
//         const depts = Array.isArray(deptData)
//           ? deptData
//           : Array.isArray(deptData.data)
//             ? deptData.data
//             : [];
//         setDepartments(depts);
//       } catch (err) {
//         console.error("Error loading departments", err);
//       }
//     };
//     fetchDepartments();
//   }, []);

//   // 2. DYNAMIC LOAD: Fetch Doctors whenever Department changes

//   useEffect(() => {
//     const fetchDoctorsByDept = async () => {
//       if (!formData.department) {
//         setDoctors([]);
//         return;
//       }

//       const user = JSON.parse(localStorage.getItem("user"));
//       if (!user?.id) return;

//       try {
//         // NOTE: Ensure this URL matches your actual backend EXACTLY!
//         const res = await fetch(
//           `https://hmsapi.emedhatechnologies.com/master/api/api/doctorss?employee_id=${user.id}&department=${encodeURIComponent(formData.department)}`
//         );
//         const docData = await res.json();

//         const doctorsList = Array.isArray(docData)
//           ? docData
//           : Array.isArray(docData.data)
//             ? docData.data
//             : [];
//         setDoctors(doctorsList);
//       } catch (err) {
//         console.error("Error loading doctors", err);
//         setDoctors([]);
//       }
//     };

//     fetchDoctorsByDept();
//   }, [formData.department]);

//   const enableEditing = () => {
//     setIsDisabled(false);
//   };

//   const loadPatientById = async (id) => {

//     const res = await fetch(`/api/patient/${id}`);
//     const data = await res.json();

//     setFormData(data);
//     setIsDisabled(false);

//   };

//   const loadPatientData = () => {
//     console.log("Reload patient data");
//   };

//   const viewPatient = async (id) => {

//     const res = await fetch(`/api/patient/${id}`);
//     const data = await res.json();

//     setFormData(data);
//     setIsDisabled(true);

//   };

//   const disableEditing = () => {
//     setIsDisabled(true);
//   };

//   const refreshForm = () => {
//     // Only try to load from API if the patient actually exists (has a 'created_at' timestamp)
//     if (formData.created_at) {
//       loadPatientById(formData.patient_id);
//     } else {
//       // If it's a new unsaved form, just clear it
//       clearForm();
//     }
//   };


//   useEffect(() => {

//     const date = new Date();
//     const id = `EM-${date.getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

//     setFormData(prev => ({
//       ...prev,
//       patient_id: id,
//       registration_date: new Date().toISOString().split("T")[0]
//     }));

//   }, []);

//   const handleChange = (e) => {

//     const { name, value, files } = e.target;

//     if (files) {
//       setFormData({ ...formData, [name]: files[0] });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }

//   };

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);

//     const filesWithPreview = files.map(file => ({
//       file,
//       preview: URL.createObjectURL(file)
//     }));

//     setMedicalFiles(prev => [...prev, ...filesWithPreview]);
//   };

//   const removeFile = (index) => {
//     const updated = [...medicalFiles];
//     updated.splice(index, 1);
//     setMedicalFiles(updated);
//   };

//   useEffect(() => {

//     if (screenAction === "add") {
//       clearForm();
//     }

//     if (screenAction === "edit") {
//       enableEditing();
//     }

//     if (screenAction === "view") {
//       disableEditing();
//     }

//     // if(screenAction === "save"){
//     //   handleSubmit();
//     // }

//     if (screenAction === "refresh") {
//       refreshForm();
//     }

//     if (screenAction === "print") {
//       printForm();
//     }

//   }, [screenAction]);

//   // This effect handles the click from the Dashboard Topbar
//   useEffect(() => {
//     if (triggerSave > 0 && screenAction === "save") {
//       handleSubmit();
//     }
//   }, [triggerSave]);

//   // const handleSubmit = async () => {

//   // if(screenAction === "add"){

//   //  await fetch("/api/patient",{
//   //   method:"POST",
//   //   headers:{'Content-Type':'application/json'},
//   //   body:JSON.stringify(formData)
//   //  });

//   // }

//   // if(screenAction === "edit"){

//   //  await fetch(`/api/patient/${formData.patient_id}`,{
//   //   method:"PUT",
//   //   headers:{'Content-Type':'application/json'},
//   //   body:JSON.stringify(formData)
//   //  });

//   // }

//   // alert("Patient Saved");

//   // };


//   const formatDate = (date) => {
//     if (!date) return null;
//     return date.split("T")[0]; // ✅ YYYY-MM-DD
//   };




//   // const handleSubmit = async () => {
//   //   const user = JSON.parse(localStorage.getItem("user"));

//   //   if (!formData.name) {
//   //     alert("Please enter patient name");
//   //     return;
//   //   }

//   //   // Create a clean payload
//   //   const payload = { ...formData };

//   //   // 1. DELETE database-managed timestamps so they don't break MySQL
//   //   delete payload.created_at;
//   //   delete payload.updated_at;

//   //   // 2. Add user ID
//   //   payload.created_by = user.id;

//   //   // 3. Fix Date Fields for MySQL (YYYY-MM-DD)
//   //   payload.dob = formatDate(formData.dob);
//   //   payload.insurance_validity = formatDate(formData.insurance_validity);
//   //   payload.registration_date = formatDate(formData.registration_date);

//   //   // 4. Fix Appointment Date for MySQL (YYYY-MM-DD HH:mm:ss)
//   //   if (payload.appointment_date) {
//   //     // Replace the 'T' with a space and remove the seconds if present
//   //     payload.appointment_date = payload.appointment_date.replace("T", " ").split(".")[0];
//   //   }

//   //   console.log("CLEAN PAYLOAD:", payload);

//   //   const method = formData.created_at || formData.hospital_id ? "PUT" : "POST";
//   //   const url = method === "POST"
//   //     ? "https://hmsapi.emedhatechnologies.com/master/api/api/patient"
//   //     : `https://hmsapi.emedhatechnologies.com/master/api/api/patient/${formData.patient_id}`;

//   //   try {
//   //     const res = await fetch(url, {
//   //       method,
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify(payload)
//   //     });

//   //     if (res.ok) {
//   //       alert("Patient Saved Successfully!");
//   //       if (method === "POST") clearForm();
//   //     } else {
//   //       const errorData = await res.json();
//   //       alert("Error: " + (errorData.message || "Failed to save"));
//   //     }
//   //   } catch (error) {
//   //     console.error("Fetch Error:", error);
//   //     alert("Network Error");
//   //   }
//   // };

//   const handleSubmit = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));

//     if (!formData.name) {
//       alert("Please enter patient name");
//       return;
//     }

//     // ✅ Aadhaar validation
//     if (
//       formData.govt_id_type === "Aadhaar" &&
//       !isOtpVerified
//     ) {
//       alert("Please verify Aadhaar OTP before saving");
//       return;
//     }


//     const formDataObj = new FormData();

//     // ✅ Clone and clean payload
//     const payload = { ...formData };

//     delete payload.created_at;
//     delete payload.updated_at;

//     payload.created_by = user.id;


//     // ✅ ONLY AFTER VERIFIED SEND 1
//     payload.aadhaar_verify = isOtpVerified ? 1 : 0;

//     // ✅ Save Aadhaar number also
//     if (formData.govt_id_type === "Aadhaar") {
//       payload.govt_id_number = Aadhar_No;
//     }


//     // ✅ Fix Dates
//     payload.dob = formatDate(formData.dob);
//     payload.insurance_validity = formatDate(formData.insurance_validity);
//     payload.registration_date = formatDate(formData.registration_date);

//     if (payload.appointment_date) {
//       payload.appointment_date = payload.appointment_date
//         .replace("T", " ")
//         .split(".")[0];
//     }

//     // ✅ Append all normal fields
//     Object.keys(payload).forEach((key) => {
//       formDataObj.append(key, payload[key] || "");
//     });

//     // ✅ Separate New Files from Existing Files
//     const existingFileNames = medicalFiles
//       .filter(item => item.isExisting)
//       .map(item => item.fileName);

//     // Send the list of existing files to keep
//     formDataObj.append("existing_files", JSON.stringify(existingFileNames));

//     // Send the actual new File objects
//     medicalFiles.forEach((item) => {
//       if (!item.isExisting) {
//         formDataObj.append("medical_files", item.file);
//       }
//     });

//     console.log("FORM DATA READY");

//     const method = formData.created_at || formData.hospital_id ? "PUT" : "POST";

//     const url =
//       method === "POST"
//         ? "https://hmsapi.emedhatechnologies.com/master/api/api/patient"
//         : `https://hmsapi.emedhatechnologies.com/master/api/api/patient/${formData.patient_id}`;

//     try {
//       const res = await fetch(url, {
//         method,
//         body: formDataObj, // ❗ NO headers here
//       });

//       if (res.ok) {
//         alert("Patient Saved Successfully!");
//         if (method === "POST") {
//           clearForm();
//           setMedicalFiles([]); // ✅ clear previews
//         }
//       } else {
//         const errorData = await res.json();
//         alert("Error: " + (errorData.message || "Failed to save"));
//       }
//     } catch (error) {
//       console.error("Fetch Error:", error);
//       alert("Network Error");
//     }
//   };

//   const printForm = () => {
//     const newWindow = window.open("", "", "width=900,height=700");

//     // Get current date for the footer/header
//     const today = new Date().toLocaleDateString();

//     const htmlContent = `
//     <html>
//       <head>
//         <title>Patient Registration - ${formData.name || 'New Patient'}</title>
//         <style>
//           body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
          
//           /* Header Section */
//           .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2c3e50; padding-bottom: 10px; margin-bottom: 20px; }
//           .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
//           .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
//           .report-title { text-align: right; }
//           .report-title h2 { margin: 0; color: #e74c3c; font-size: 18px; }
          
//           /* Section Styling */
//           .section-header { background: #f2f4f4; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2c3e50; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
          
//           /* Data Grid */
//           .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
//           .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 4px 0; }
//           .label { font-weight: 600; width: 150px; color: #555; }
//           .value { flex: 1; color: #000; }
//           .full-width { grid-column: span 2; }

//           /* Footer */
//           .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
//           .sig-box { margin-top: 40px; display: flex; justify-content: space-between; }
//           .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

//           @media print {
//             button { display: none; }
//             body { padding: 20px; }
//           }
//         </style>
//       </head>
//       <body>
//         <div class="header">
//           <div class="hospital-info">
//             <h1>EMEDHA CARE HOSPITAL</h1>
//             <p>123 Medical Park, Health City - 560001</p>
//             <p>Phone: +91 98765 43210 | Email: contact@citycare.com</p>
//           </div>
//           <div class="report-title">
//             <h2>PATIENT REGISTRATION</h2>
//             <p>Date: ${today}</p>
//           </div>
//         </div>

//         <div class="section-header">Basic Patient Details</div>
//         <div class="data-grid">
//           <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id || 'N/A'}</span></div>
//           <div class="data-item"><span class="label">Full Name:</span> <span class="value">${formData.name || ''}</span></div>
//           <div class="data-item"><span class="label">Gender:</span> <span class="value">${formData.gender || ''}</span></div>
//           <div class="data-item"><span class="label">Age / DOB:</span> <span class="value">${formData.age || ''} Yrs / ${formData.dob || ''}</span></div>
//           <div class="data-item"><span class="label">Blood Group:</span> <span class="value">${formData.blood_group || ''}</span></div>
//           <div class="data-item"><span class="label">Marital Status:</span> <span class="value">${formData.marital_status || ''}</span></div>
//         </div>

//         <div class="section-header">Contact & Identification</div>
//         <div class="data-grid">
//           <div class="data-item"><span class="label">Mobile:</span> <span class="value">${formData.mobile || ''}</span></div>
//           <div class="data-item"><span class="label">Email:</span> <span class="value">${formData.email || ''}</span></div>
//           <div class="data-item full-width"><span class="label">Address:</span> <span class="value">${formData.address || ''}, ${formData.city || ''}, ${formData.state || ''} - ${formData.pincode || ''}</span></div>
//           <div class="data-item"><span class="label">${formData.govt_id_type || 'ID'}:</span> <span class="value">${formData.govt_id_number || ''}</span></div>
//         </div>

//         <div class="section-header">Appointment & Medical Details</div>
//         <div class="data-grid">
//           <div class="data-item"><span class="label">Department:</span> <span class="value">${formData.department || ''}</span></div>
//           <div class="data-item"><span class="label">Consultant:</span> <span class="value">Dr. ${formData.doctor || ''}</span></div>
//           <div class="data-item"><span class="label">Appt Date:</span> <span class="value">${formData.appointment_date || ''}</span></div>
//           <div class="data-item"><span class="label">Visit Type:</span> <span class="value">${formData.visit_type || ''}</span></div>
//           <div class="data-item full-width"><span class="label">Allergies:</span> <span class="value">${formData.allergies || 'None'}</span></div>
//         </div>

//         <div class="sig-box">
//           <div class="sig">Patient/Guardian Signature</div>
//           <div class="sig">Authorized Signatory</div>
//         </div>

//         <div class="footer">
//           This is a computer-generated registration form and does not require a physical stamp for internal use.
//         </div>
//       </body>
//     </html>
//   `;

//     newWindow.document.write(htmlContent);
//     newWindow.document.close();

//     // Give a small timeout for styles to load before printing
//     setTimeout(() => {
//       newWindow.print();
//       newWindow.close();
//     }, 500);
//   };


//   // ====================== ADD THESE STATES ======================

//   const [Aadhar_No, setAadhar_No] = useState('');
//   const [OTP, setOTP] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [isOtpVerified, setIsOtpVerified] = useState(false);
//   const [error, setError] = useState('');

//   // ====================== ADD THIS FUNCTION ======================

//   const handleInputChangev = (e) => {
//     const { name, value } = e.target;

//     if (name === 'Aadhar_No') {
//       // only 12 digits
//       const numericValue = value.replace(/\D/g, '').slice(0, 12);
//       setAadhar_No(numericValue);

//       // also set govt id number
//       setFormData((prev) => ({
//         ...prev,
//         govt_id_number: numericValue,
//       }));
//     } else if (name === 'OTP') {
//       setOTP(value);
//     }
//   };

//   // ====================== SEND OTP ======================

//   const sendOtp = async () => {

//     if (!Aadhar_No || Aadhar_No.length !== 12) {
//       alert('Please enter valid 12 digit Aadhaar Number');
//       return;
//     }

//     try {

//       const response = await axios.post(
//         'https://hmsapi.emedhatechnologies.com/master/api/api/send-aadhar-otp',
//         { Aadhar_No }
//       );

//       if (response.data.ref_id) {
//         setIsOtpSent(true);
//         alert('OTP Sent Successfully');
//       }

//     } catch (error) {

//       console.log(error);

//       setError('Error sending OTP');
//       alert('Error sending OTP');

//     }
//   };

//   // ====================== VERIFY OTP ======================

//   const verifyOtp = async () => {

//     if (!OTP) {
//       alert('Please enter OTP');
//       return;
//     }

//     try {

//       const userId =
//         formData.patient_id
//       //  ||
//       // selectedPatient?.patient_id;

//       const response = await axios.post(
//         'https://hmsapi.emedhatechnologies.com/master/api/api/verify-aadhar-otp',
//         {
//           otp: OTP,
//           Aadhar_No,
//           userId
//         }
//       );

//       console.log(response.data);

//       if (response.data.status === 'VALID') {

//         setIsOtpVerified(true);
//         setIsOtpSent(false);
//         setError('');

//         alert('Aadhaar Verified Successfully');

//       } else {

//         setError('OTP verification failed');
//         alert('OTP verification failed');

//       }

//     } catch (error) {

//       console.log(error);

//       setError('Error verifying OTP');
//       alert('Error verifying OTP');

//     }
//   };

//   // ====================== RESET ======================

//   const resetProcess = () => {

//     setAadhar_No('');
//     setOTP('');
//     setIsOtpSent(false);
//     setIsOtpVerified(false);
//     setError('');

//   };

//   return (

//     <div className="registration-container fade-in" id="print-area">
//       {(screenAction === "edit" || screenAction === "view") && (

//         <div className="patient-search">

//           <label>Search Patient</label>

//           <input
//             type="text"
//             value={searchText}
//             placeholder="Search by Name / ID / Mobile"
//             onChange={(e) => searchPatients(e.target.value)}
//           />

//           {showDropdown && patients.length > 0 && (

//             <div className="patient-dropdown">

//               {patients.map((p) => (
//                 <div
//                   key={p.patient_id}
//                   className="patient-item"
//                   onClick={() => selectPatient(p)}
//                 >

//                   {p.name} | {p.patient_id} | {p.mobile}

//                 </div>
//               ))}

//             </div>

//           )}

//         </div>

//       )}

//       {screenAction === "view" && formData.patient_id && (
//         <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', marginTop: '10px' }}>
//           <button
//             type="button"
//             onClick={() => alert(`Share Patient details (${formData.patient_id}) via WhatsApp!`)}
//             style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#25D366', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(37, 211, 102, 0.3)', height: '36px' }}
//             title="Share via WhatsApp"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
//               <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
//             </svg>
//             WhatsApp
//           </button>
//         </div>
//       )}


//       <form className="luxury-form" >

//         {/* BASIC DETAILS */}

//         {/* BASIC DETAILS */}
//         <div className="form-section-header">
//           <h3>Basic Patient Details</h3>
//         </div>

//         {/* ROW 1: Patient ID, Full Name, Gender, DOB, Age (All in one line on large screens) */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

//           <div className="input-box read-only" style={{ flex: '1 1 120px' }}>
//             <label>Patient ID</label>
//             <input type="text" name="patient_id" value={formData.patient_id || ""} readOnly />
//           </div>

//           <div className="input-box" style={{ flex: '2 1 200px' }}>
//             <label>Full Name</label>
//             <input type="text" name="name" onChange={handleChange} required value={formData.name || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '0.8 1 100px' }}>
//             <label>Gender</label>
//             <select name="gender" onChange={handleChange} required value={formData.gender || ""} disabled={isDisabled}>
//               <option value="">Select</option>
//               <option>Male</option>
//               <option>Female</option>
//               <option>Other</option>
//             </select>
//           </div>

//           <div className="input-box" style={{ flex: '1 1 130px' }}>
//             <label>Date of Birth</label>
//             <input type="date" name="dob" onChange={handleChange} value={formData.dob || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '0.5 1 70px' }}>
//             <label>Age</label>
//             <input type="number" name="age" onChange={handleChange} value={formData.age || ""} disabled={isDisabled} />
//           </div>

//         </div>

//         {/* ROW 2: Blood Group & Marital Status (Reduced widths) */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

//           {/* Changed flex-grow to 0, and base width to 150px */}
//           <div className="input-box" style={{ flex: '0 1 150px' }}>
//             <label>Blood Group</label>
//             <select name="blood_group" onChange={handleChange} value={formData.blood_group || ""} disabled={isDisabled}>
//               <option value="">Select</option>
//               <option>A+</option>
//               <option>B+</option>
//               <option>O+</option>
//               <option>AB+</option>
//               <option>A-</option>
//               <option>B-</option>
//               <option>O-</option>
//               <option>AB-</option>
//             </select>
//           </div>

//           {/* Changed flex-grow to 0, and base width to 150px */}
//           <div className="input-box" style={{ flex: '0 1 150px' }}>
//             <label>Marital Status</label>
//             <select name="marital_status" onChange={handleChange} value={formData.marital_status || ""} disabled={isDisabled}>
//               <option value="">Select</option>
//               <option>Single</option>
//               <option>Married</option>
//               <option>Divorced</option>
//             </select>
//           </div>

//         </div>

//         {/* CONTACT INFORMATION */}

//         {/* CONTACT INFORMATION */}
//         <div className="form-section-header">
//           <h3>Contact Information</h3>
//         </div>

//         {/* ROW 1: Mobile, WhatsApp, OTP, Email */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px', alignItems: 'flex-end' }}>

//           <div className="input-box" style={{ flex: '1.5 1 180px' }}>
//             <label>Mobile Number</label>
//             <input type="tel" name="mobile" onChange={handleChange} value={formData.mobile || ""} disabled={isDisabled} />
//           </div>

//           {/* WhatsApp Checkbox (Compact) */}
//           <div className="input-box" style={{ flex: '0 1 100px', display: 'flex', alignItems: 'center', height: '42px', paddingBottom: '5px' }}>
//             <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0, fontWeight: 'bold', fontSize: '13px' }}>
//               <input type="checkbox" name="whatsapp_yn" disabled={isDisabled} style={{ width: '16px', height: '16px', margin: 0 }} /> WhatsApp?
//             </label>
//           </div>

//           <div className="input-box" style={{ flex: '1 1 120px' }}>
//             <label>OTP</label>
//             <input type="text" name="otp" placeholder="Enter OTP" disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '2 1 250px' }}>
//             <label>Email</label>
//             <input type="email" name="email" onChange={handleChange} value={formData.email || ""} disabled={isDisabled} />
//           </div>

//         </div>

//         {/* ROW 2: Address, City, State, Pin Code */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>

//           {/* Address takes up the most space (flex: 3), height reduced to match inputs */}
//           <div className="input-box" style={{ flex: '3 1 250px' }}>
//             <label>Address</label>
//             <textarea
//               name="address"
//               onChange={handleChange}
//               value={formData.address || ""}
//               disabled={isDisabled}
//               rows="1"
//               style={{ height: '42px', minHeight: '42px', padding: '10px' }}
//             />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 120px' }}>
//             <label>City</label>
//             <input type="text" name="city" onChange={handleChange} value={formData.city || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 120px' }}>
//             <label>State</label>
//             {/* Default value set to Telangana if empty */}
//             <input type="text" name="state" onChange={handleChange} value={formData.state || "Telangana"} disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 100px' }}>
//             <label>Pin Code</label>
//             <input type="text" name="pincode" onChange={handleChange} value={formData.pincode || ""} disabled={isDisabled} />
//           </div>

//         </div>

//         {/* IDENTIFICATION */}

//         {/* IDENTIFICATION & EMERGENCY CONTACT */}
//         <div className="form-section-header">
//           <h3>Identification & Emergency Contact</h3>
//         </div>

//         {/* ROW: Govt ID, ID Number, Contact Name, Relationship, Emergency Phone */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

//           {/* <div className="input-box" style={{ flex: '1 1 130px' }}>
//             <label>Government ID</label>
//             <select name="govt_id_type" onChange={handleChange} value={formData.govt_id_type || ""} disabled={isDisabled}>
//               <option value="">Select</option>
//               <option>Aadhaar</option>
//               <option>Passport</option>
//               <option>Driving License</option>
//             </select>
//           </div>

//           <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//             <label>ID Number</label>
//             <input type="text" name="govt_id_number" onChange={handleChange} value={formData.govt_id_number || ""} disabled={isDisabled} />
//           </div> */}
//           <div className="input-box" style={{ flex: '1 1 130px' }}>
//             <label>Government ID</label>

//             <select
//               name="govt_id_type"
//               onChange={handleChange}
//               value={formData.govt_id_type || ""}
//               disabled={isDisabled}
//             >
//               <option value="">Select</option>
//               <option>Aadhaar</option>
//               <option>Passport</option>
//               <option>Driving License</option>
//             </select>
//           </div>

//           {/* ================= AADHAAR VERIFICATION ================= */}

//           {formData.govt_id_type === "Aadhaar" ? (

//             <div
//               style={{
//                 display: 'flex',
//                 alignItems: 'flex-end',
//                 gap: '10px',
//                 flexWrap: 'wrap',
//                 flex: '2 1 400px'
//               }}
//             >

//               {!isOtpSent && !isOtpVerified && (
//                 <div className="input-box" style={{ flex: '1 1 180px' }}>
//                   <label>Aadhaar Number</label>

//                   <input
//                     type="text"
//                     name="Aadhar_No"
//                     placeholder="Enter 12 Digit Aadhaar"
//                     value={Aadhar_No}
//                     onChange={handleInputChangev}
//                     maxLength={12}
//                     disabled={isDisabled}
//                   />
//                 </div>
//               )}

//               {isOtpSent && !isOtpVerified && (
//                 <div className="input-box" style={{ flex: '1 1 120px' }}>
//                   <label>Enter OTP</label>

//                   <input
//                     type="text"
//                     name="OTP"
//                     placeholder="Enter OTP"
//                     value={OTP}
//                     onChange={handleInputChangev}
//                     disabled={isDisabled}
//                   />
//                 </div>
//               )}

//               {/* SEND OTP BUTTON */}

//               {!isOtpSent && !isOtpVerified && (
//                 <button
//                   type="button"
//                   onClick={sendOtp}
//                   disabled={isDisabled}
//                   style={{
//                     padding: '10px 14px',
//                     background: '#007bff',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                     height: '42px'
//                   }}
//                 >
//                   Send OTP
//                 </button>
//               )}

//               {/* VERIFY BUTTON */}

//               {isOtpSent && !isOtpVerified && (
//                 <button
//                   type="button"
//                   onClick={verifyOtp}
//                   disabled={isDisabled}
//                   style={{
//                     padding: '10px 14px',
//                     background: 'green',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer',
//                     height: '42px'
//                   }}
//                 >
//                   Verify OTP
//                 </button>
//               )}

//               {/* VERIFIED */}

//               {isOtpVerified && (
//                 <>
//                   <div
//                     style={{
//                       color: 'green',
//                       fontWeight: 'bold',
//                       paddingBottom: '10px'
//                     }}
//                   >
//                     ✓ Verified
//                   </div>

//                   {/* <button
//                     type="button"
//                     onClick={resetProcess}
//                     style={{
//                       padding: '10px 14px',
//                       background: '#dc3545',
//                       color: '#fff',
//                       border: 'none',
//                       borderRadius: '5px',
//                       cursor: 'pointer',
//                       height: '42px'
//                     }}
//                   >
//                     Reset
//                   </button> */}
//                 </>
//               )}

//               {error && (
//                 <div style={{ color: 'red', fontSize: '13px' }}>
//                   {error}
//                 </div>
//               )}

//             </div>

//           ) : (

//             <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//               <label>ID Number</label>

//               <input
//                 type="text"
//                 name="govt_id_number"
//                 onChange={handleChange}
//                 value={formData.govt_id_number || ""}
//                 disabled={isDisabled}
//               />
//             </div>

//           )}
//           <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//             <label>Contact Name</label>
//             <input type="text" name="emergency_name" onChange={handleChange} value={formData.emergency_name || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 120px' }}>
//             <label>Relationship</label>
//             <input type="text" name="emergency_relation" onChange={handleChange} value={formData.emergency_relation || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box" style={{ flex: '1.5 1 150px' }}>
//             <label>Emergency Phone</label>
//             <input type="tel" name="emergency_phone" onChange={handleChange} value={formData.emergency_phone || ""} disabled={isDisabled} />
//           </div>

//         </div>


//         {/* MEDICAL */}

//         {/* MEDICAL INFORMATION */}
//         <div className="form-section-header">
//           <h3>Medical Information</h3>
//         </div>

//         {/* ROW 1: All 4 Medical fields on one line */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

//           <div className="input-box" style={{ flex: '1 1 180px' }}>
//             <label>Known Allergies</label>
//             <textarea
//               name="allergies"
//               onChange={handleChange}
//               value={formData.allergies || ""}
//               disabled={isDisabled}
//               rows="2"
//               style={{ overflowY: 'auto', resize: 'vertical' }}
//             />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 180px' }}>
//             <label>Existing Conditions</label>
//             <textarea
//               name="conditions"
//               onChange={handleChange}
//               value={formData.conditions || ""}
//               disabled={isDisabled}
//               rows="2"
//               style={{ overflowY: 'auto', resize: 'vertical' }}
//             />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 180px' }}>
//             <label>Current Medications</label>
//             <textarea
//               name="medications"
//               onChange={handleChange}
//               value={formData.medications || ""}
//               disabled={isDisabled}
//               rows="2"
//               style={{ overflowY: 'auto', resize: 'vertical' }}
//             />
//           </div>

//           <div className="input-box" style={{ flex: '1 1 180px' }}>
//             <label>Previous Medical History</label>
//             <textarea
//               name="medical_history"
//               onChange={handleChange}
//               value={formData.medical_history || ""}
//               disabled={isDisabled}
//               rows="2"
//               style={{ overflowY: 'auto', resize: 'vertical' }}
//             />
//           </div>

//         </div>

//         {/* ROW 2: File Upload */}
//         {/* ROW 2: File Upload (Reduced Width) */}
//         <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

//           {/* Changed flex to 0 1 300px so it only takes up necessary space */}
//           <div className="input-box" style={{ flex: '0 1 280px' }}>
//             <label>Upload Medical Records</label>
//             <input
//               type="file"
//               name="medical_file"
//               multiple
//               onChange={handleFileChange}
//               disabled={isDisabled}
//             />
//           </div>

//         </div>

//         {/* PREVIEW CONTAINER */}
//         <div className="preview-container">
//           {Array.isArray(medicalFiles) && medicalFiles.length > 0 ? (
//             medicalFiles.map((item, index) => (
//               <div key={index} className="preview-box">
//                 <img
//                   src={item.preview}
//                   alt="medical record"
//                   onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=File+Error'; }}
//                 />
//                 {!isDisabled && (
//                   <button
//                     type="button"
//                     className="remove-btn"
//                     onClick={() => removeFile(index)}
//                   >
//                     ✕
//                   </button>
//                 )}
//               </div>
//             ))
//           ) : (
//             <p style={{ fontSize: '12px', color: '#999', marginLeft: '10px' }}>No records uploaded.</p>
//           )}
//         </div>

//         {/* INSURANCE */}

//         <div className="form-section-header">
//           <h3>Insurance Details</h3>
//         </div>

//         <div className="form-grid">

//           <div className="input-box">
//             <label>Insurance Provider</label>
//             <input type="text" name="insurance_provider" onChange={handleChange} value={formData.insurance_provider || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box">
//             <label>Policy Number</label>
//             <input type="text" name="policy_number" onChange={handleChange} value={formData.policy_number || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box">
//             <label>Insurance Validity</label>
//             <input type="date" name="insurance_validity" onChange={handleChange} value={formData.insurance_validity || ""} disabled={isDisabled} />
//           </div>

//         </div>


//         {/* APPOINTMENT */}
//         {/* 
//         <div className="form-section-header">
//           <h3>Appointment Details</h3>
//         </div>

//         <div className="form-grid">

//           <div className="input-box">
//             <label>Department</label>
//             <select name="department" onChange={handleDepartmentChange} value={formData.department || ""} disabled={isDisabled}>
//               <option value="">Select Department</option>
//               {departments.filter(d => d.status === 'Active').map(d => (
//                 <option key={d.dept_cd} value={d.dept_name.trim()}>{d.dept_name.trim()}</option>
//               ))}
//             </select>
//           </div>

//           <div className="input-box">
//             <label>Doctor Name</label>
//             <select name="doctor" onChange={handleDoctorChange} value={formData.doctor || ""} disabled={isDisabled || !formData.department}>
//               <option value="">Select Doctor</option>
//               {/* 1. No .filter() needed here because the API already filtered by department.
//         2. Use .trim() to strip trailing spaces from "Dr. Ravi Kumar " 

//               {doctors.map(d => (
//                 <option key={d.doc_cd} value={d.doctor_name.trim()}>{d.doctor_name.trim()}</option>
//               ))}
//             </select>
//           </div>

//           <div className="input-box">
//             <label>Appointment Date</label>
//             <input type="datetime-local" name="appointment_date" onChange={handleChange} min={getCurrentLocalDateTime()} value={formData.appointment_date || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box">
//             <label>Visit Type</label>
//             <select name="visit_type" onChange={handleChange} value={formData.visit_type || ""} disabled={isDisabled}>
//               <option>New</option>
//               <option>Follow-up</option>
//               <option>Emergency</option>
//             </select>
//           </div>

//         </div> */}


//         {/* ADMIN */}

//         <div className="form-section-header">
//           <h3>Administrative Details</h3>
//         </div>

//         <div className="form-grid">

//           <div className="input-box">
//             <label>Registration Date</label>
//             <input type="date" name="registration_date" value={formData.registration_date || ""} disabled={isDisabled} />
//           </div>

//           <div className="input-box">
//             <label>Registration Fee (Editable)</label>
//             <input
//               type="number"
//               name="registration_fee"
//               onChange={handleChange}
//               value={formData.registration_fee || ""}
//               disabled={isDisabled}
//               placeholder="Auto-fills from Doctor"
//             />
//           </div>
//           <div className="input-box">
//             <label>Referred By</label>
//             <input type="text" name="referred_by" onChange={handleChange} value={formData.referred_by || ""} disabled={isDisabled} />
//           </div>

//         </div>


//       </form>
//     </div>
//   );
// };

// export default NewPatientRegistration;







import React, { useState, useEffect, } from "react";
import "./NewPatientRegistration.css";
import axios from "axios";

const NewPatientRegistration = ({ screenAction, triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [patients, setPatients] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [medicalFiles, setMedicalFiles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const initialFormState = {
    patient_id: "",
    name: "",
    gender: "",
    dob: "",
    age: "",
    blood_group: "",
    marital_status: "",

    mobile: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",

    govt_id_type: "",
    govt_id_number: "",

    emergency_name: "",
    emergency_relation: "",
    emergency_phone: "",

    allergies: "",
    conditions: "",
    medications: "",
    medical_history: "",
    medical_file: null,

    insurance_provider: "",
    policy_number: "",
    insurance_validity: "",

    department: "",
    doctor: "",
    appointment_date: "",
    visit_type: "",

    registration_date: "",
    registration_fee: "",
    referred_by: ""
  };
  const [formData, setFormData] = useState(initialFormState);
  const user = JSON.parse(localStorage.getItem("user"));


 

  const searchPatients = async (text) => {

    setSearchText(text);

    if (text.length < 2) {
      setPatients([]);
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));

    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patients/search?q=${text}&employee_id=${user.id}`);
    const data = await res.json();

    setPatients(data);
    setShowDropdown(true);
  };



  const selectPatient = (patient) => {
    const cleanDate = (d) => (d ? d.split("T")[0] : "");
    const cleanDateTime = (d) => {
      if (!d) return "";
      return d.replace(" ", "T").slice(0, 16);
    };

    setFormData({
      ...patient,
      dob: cleanDate(patient.dob),
      insurance_validity: cleanDate(patient.insurance_validity),
      registration_date: cleanDate(patient.registration_date),
      appointment_date: cleanDateTime(patient.appointment_date),
    });

    // ✅ 1. Identify the file source (check both singular and plural keys)
    const rawFiles = patient.medical_files || patient.medical_file;

    if (rawFiles) {
      try {
        // ✅ 2. Parse if it's a string, otherwise use as is
        const fileList = typeof rawFiles === "string" ? JSON.parse(rawFiles) : rawFiles;

        if (Array.isArray(fileList)) {
          const existingFiles = fileList.map((fileName) => ({
            file: null,
            // ✅ 3. Ensure this URL matches your backend upload folder exactly
            preview: `${fileName}`,
            isExisting: true,
            fileName: fileName
          }));
          setMedicalFiles(existingFiles);
        }
      } catch (e) {
        console.error("Error parsing medical files:", e);
        // Fallback if it's just a single string and not a JSON array
        if (typeof rawFiles === "string" && rawFiles.length > 4) {
          setMedicalFiles([{
            file: null,
            preview: `${rawFiles}`,
            isExisting: true,
            fileName: rawFiles
          }]);
        }
      }
    } else {
      setMedicalFiles([]);
    }

    setSearchText(`${patient.name} | ${patient.patient_id} | ${patient.mobile}`);
    setShowDropdown(false);
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };


  // Gets current local date & time in YYYY-MM-DDThh:mm format
  const getCurrentLocalDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  const clearForm = () => {

    const date = new Date();
    const newId = `EM-${date.getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

    setFormData({
      ...initialFormState,
      patient_id: newId,
      registration_date: new Date().toISOString().split("T")[0]
    });

    setSearchText(""); // Clear the search bar too
    setIsDisabled(false);
    console.log("Form Cleared");

  };
  // When Department Changes: Update state and clear the previously selected doctor
  const handleDepartmentChange = (e) => {
    const val = e.target.value;
    setFormData(prev => ({ ...prev, department: val, doctor: "", registration_fee: "" }));
  };

  // When Doctor Changes: Auto-fill the registration fee based on the selected doctor
  // When Doctor Changes: Auto-fill the registration fee based on the selected doctor
  const handleDoctorChange = (e) => {
    const docName = e.target.value;

    // Find the full doctor object (using trim to avoid space issues)
    const selectedDoc = doctors.find(d => d.doctor_name.trim() === docName.trim());

    setFormData(prev => ({
      ...prev,
      doctor: docName,
      // Ensure we format the fee to 2 decimal places if it exists
      registration_fee: selectedDoc ? parseFloat(selectedDoc.consultation_fee).toFixed(2) : ""
    }));
  };

  // 1. INITIAL LOAD: Fetch Departments
  useEffect(() => {
    const fetchDepartments = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.id) return;

      try {
        const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments?employee_id=${user.id}`);
        const deptData = await res.json();

        // Support both array or { success, data } response
        const depts = Array.isArray(deptData)
          ? deptData
          : Array.isArray(deptData.data)
            ? deptData.data
            : [];
        setDepartments(depts);
      } catch (err) {
        console.error("Error loading departments", err);
      }
    };
    fetchDepartments();
  }, []);

  // 2. DYNAMIC LOAD: Fetch Doctors whenever Department changes

  useEffect(() => {
    const fetchDoctorsByDept = async () => {
      if (!formData.department) {
        setDoctors([]);
        return;
      }

      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.id) return;

      try {
        // NOTE: Ensure this URL matches your actual backend EXACTLY!
        const res = await fetch(
          `https://hmsapi.emedhatechnologies.com/master/api/api/doctorss?employee_id=${user.id}&department=${encodeURIComponent(formData.department)}`
        );
        const docData = await res.json();

        const doctorsList = Array.isArray(docData)
          ? docData
          : Array.isArray(docData.data)
            ? docData.data
            : [];
        setDoctors(doctorsList);
      } catch (err) {
        console.error("Error loading doctors", err);
        setDoctors([]);
      }
    };

    fetchDoctorsByDept();
  }, [formData.department]);

  const enableEditing = () => {
    setIsDisabled(false);
  };

  const loadPatientById = async (id) => {

    const res = await fetch(`/api/patient/${id}`);
    const data = await res.json();

    setFormData(data);
    setIsDisabled(false);

  };

  const loadPatientData = () => {
    console.log("Reload patient data");
  };

  const viewPatient = async (id) => {

    const res = await fetch(`/api/patient/${id}`);
    const data = await res.json();

    setFormData(data);
    setIsDisabled(true);

  };

  const disableEditing = () => {
    setIsDisabled(true);
  };

  const refreshForm = () => {
    // Only try to load from API if the patient actually exists (has a 'created_at' timestamp)
    if (formData.created_at) {
      loadPatientById(formData.patient_id);
    } else {
      // If it's a new unsaved form, just clear it
      clearForm();
    }
  };


  useEffect(() => {

    const date = new Date();
    const id = `EM-${date.getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

    setFormData(prev => ({
      ...prev,
      patient_id: id,
      registration_date: new Date().toISOString().split("T")[0]
    }));

  }, []);

  const handleChange = (e) => {

    const { name, value, files } = e.target;

    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }

  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const filesWithPreview = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));

    setMedicalFiles(prev => [...prev, ...filesWithPreview]);
  };

  const removeFile = (index) => {
    const updated = [...medicalFiles];
    updated.splice(index, 1);
    setMedicalFiles(updated);
  };

  useEffect(() => {

    if (screenAction === "add") {
      clearForm();
    }

    if (screenAction === "edit") {
      enableEditing();
    }

    if (screenAction === "view") {
      disableEditing();
    }

    // if(screenAction === "save"){
    //   handleSubmit();
    // }

    if (screenAction === "refresh") {
      refreshForm();
    }

    if (screenAction === "print") {
      printForm();
    }

  }, [screenAction]);

  // This effect handles the click from the Dashboard Topbar
  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") {
      handleSubmit();
    }
  }, [triggerSave]);

 

  const formatDate = (date) => {
    if (!date) return null;
    return date.split("T")[0]; // ✅ YYYY-MM-DD
  };



  const handleSubmit = async () => {

    const user = JSON.parse(localStorage.getItem("user"));

    if (!formData.name) {
      alert("Please enter patient name");
      return;
    }

    // ✅ Aadhaar validation
    if (
      formData.govt_id_type === "Aadhaar" &&
      !isOtpVerified
    ) {
      alert("Please verify Aadhaar OTP before saving");
      return;
    }

    const formDataObj = new FormData();

    // ✅ Clone payload
    const payload = { ...formData };

    delete payload.created_at;
    delete payload.updated_at;

    // ✅ User
    payload.created_by = user.id;

    // ✅ Aadhaar verify
    payload.aadhaar_verify = isOtpVerified ? 1 : 0;

    // ✅ Save Aadhaar number
    if (formData.govt_id_type === "Aadhaar") {
      payload.govt_id_number = Aadhar_No;
    }

    // ✅ Optional date fields
    payload.dob =
      formData.dob
        ? formatDate(formData.dob)
        : null;

    payload.insurance_validity =
      formData.insurance_validity
        ? formatDate(formData.insurance_validity)
        : null;

    payload.registration_date =
      formData.registration_date
        ? formatDate(formData.registration_date)
        : null;

    // ✅ Appointment date
    if (payload.appointment_date) {

      payload.appointment_date =
        payload.appointment_date
          .replace("T", " ")
          .split(".")[0];

    } else {

      payload.appointment_date = null;

    }

    // ✅ Append all fields
    Object.keys(payload).forEach((key) => {

      formDataObj.append(
        key,
        payload[key] ?? ""
      );

    });

    // ✅ Existing files
    const existingFileNames = medicalFiles
      .filter(item => item.isExisting)
      .map(item => item.fileName);

    formDataObj.append(
      "existing_files",
      JSON.stringify(existingFileNames)
    );

    // ✅ New files
    medicalFiles.forEach((item) => {

      if (!item.isExisting) {
        formDataObj.append(
          "medical_files",
          item.file
        );
      }

    });

    console.log("FORM DATA READY");

    const method =
      formData.created_at ||
        formData.hospital_id
        ? "PUT"
        : "POST";

    const url =
      method === "POST"
        ? "https://hmsapi.emedhatechnologies.com/master/api/api/patient"
        : `https://hmsapi.emedhatechnologies.com/master/api/api/patient/${formData.patient_id}`;

    try {

      const res = await fetch(url, {
        method,
        body: formDataObj,
      });

      if (res.ok) {

        alert("Patient Saved Successfully!");

        if (method === "POST") {

          clearForm();
          setMedicalFiles([]);

        }

      } else {

        const errorData = await res.json();

        alert(
          "Error: " +
          (errorData.message || "Failed to save")
        );

      }

    } catch (error) {

      console.error("Fetch Error:", error);

      alert("Network Error");

    }

  };

  const printForm = () => {
    const newWindow = window.open("", "", "width=900,height=700");

    // Get current date for the footer/header
    const today = new Date().toLocaleDateString();

    const htmlContent = `
    <html>
      <head>
        <title>Patient Registration - ${formData.name || 'New Patient'}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
          
          /* Header Section */
          .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2c3e50; padding-bottom: 10px; margin-bottom: 20px; }
          .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
          .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
          .report-title { text-align: right; }
          .report-title h2 { margin: 0; color: #e74c3c; font-size: 18px; }
          
          /* Section Styling */
          .section-header { background: #f2f4f4; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2c3e50; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
          
          /* Data Grid */
          .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
          .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 4px 0; }
          .label { font-weight: 600; width: 150px; color: #555; }
          .value { flex: 1; color: #000; }
          .full-width { grid-column: span 2; }

          /* Footer */
          .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
          .sig-box { margin-top: 40px; display: flex; justify-content: space-between; }
          .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

          @media print {
            button { display: none; }
            body { padding: 20px; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="hospital-info">
            <h1>EMEDHA CARE HOSPITAL</h1>
            <p>123 Medical Park, Health City - 560001</p>
            <p>Phone: +91 98765 43210 | Email: contact@citycare.com</p>
          </div>
          <div class="report-title">
            <h2>PATIENT REGISTRATION</h2>
            <p>Date: ${today}</p>
          </div>
        </div>

        <div class="section-header">Basic Patient Details</div>
        <div class="data-grid">
          <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id || 'N/A'}</span></div>
          <div class="data-item"><span class="label">Full Name:</span> <span class="value">${formData.name || ''}</span></div>
          <div class="data-item"><span class="label">Gender:</span> <span class="value">${formData.gender || ''}</span></div>
          <div class="data-item"><span class="label">Age / DOB:</span> <span class="value">${formData.age || ''} Yrs / ${formData.dob || ''}</span></div>
          <div class="data-item"><span class="label">Blood Group:</span> <span class="value">${formData.blood_group || ''}</span></div>
          <div class="data-item"><span class="label">Marital Status:</span> <span class="value">${formData.marital_status || ''}</span></div>
        </div>

        <div class="section-header">Contact & Identification</div>
        <div class="data-grid">
          <div class="data-item"><span class="label">Mobile:</span> <span class="value">${formData.mobile || ''}</span></div>
          <div class="data-item"><span class="label">Email:</span> <span class="value">${formData.email || ''}</span></div>
          <div class="data-item full-width"><span class="label">Address:</span> <span class="value">${formData.address || ''}, ${formData.city || ''}, ${formData.state || ''} - ${formData.pincode || ''}</span></div>
          <div class="data-item"><span class="label">${formData.govt_id_type || 'ID'}:</span> <span class="value">${formData.govt_id_number || ''}</span></div>
        </div>

        <div class="section-header">Appointment & Medical Details</div>
        <div class="data-grid">
          <div class="data-item"><span class="label">Department:</span> <span class="value">${formData.department || ''}</span></div>
          <div class="data-item"><span class="label">Consultant:</span> <span class="value">Dr. ${formData.doctor || ''}</span></div>
          <div class="data-item"><span class="label">Appt Date:</span> <span class="value">${formData.appointment_date || ''}</span></div>
          <div class="data-item"><span class="label">Visit Type:</span> <span class="value">${formData.visit_type || ''}</span></div>
          <div class="data-item full-width"><span class="label">Allergies:</span> <span class="value">${formData.allergies || 'None'}</span></div>
        </div>

        <div class="sig-box">
          <div class="sig">Patient/Guardian Signature</div>
          <div class="sig">Authorized Signatory</div>
        </div>

        <div class="footer">
          This is a computer-generated registration form and does not require a physical stamp for internal use.
        </div>
      </body>
    </html>
  `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();

    // Give a small timeout for styles to load before printing
    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };


  // ====================== ADD THESE STATES ======================

  const [Aadhar_No, setAadhar_No] = useState('');
  const [OTP, setOTP] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [error, setError] = useState('');

  // ====================== ADD THIS FUNCTION ======================

  const handleInputChangev = (e) => {
    const { name, value } = e.target;

    if (name === 'Aadhar_No') {
      // only 12 digits
      const numericValue = value.replace(/\D/g, '').slice(0, 12);
      setAadhar_No(numericValue);

      // also set govt id number
      setFormData((prev) => ({
        ...prev,
        govt_id_number: numericValue,
      }));
    } else if (name === 'OTP') {
      setOTP(value);
    }
  };

  // ====================== SEND OTP ======================

  const sendOtp = async () => {

    if (!Aadhar_No || Aadhar_No.length !== 12) {
      alert('Please enter valid 12 digit Aadhaar Number');
      return;
    }

    try {

      const response = await axios.post(
        'https://hmsapi.emedhatechnologies.com/master/api/api/send-aadhar-otp',
        { Aadhar_No }
      );

      if (response.data.ref_id) {
        setIsOtpSent(true);
        alert('OTP Sent Successfully');
      }

    } catch (error) {

      console.log(error);

      setError('Error sending OTP');
      alert('Error sending OTP');

    }
  };

  // ====================== VERIFY OTP ======================

  const verifyOtp = async () => {

    if (!OTP) {
      alert('Please enter OTP');
      return;
    }

    try {

      const userId =
        formData.patient_id
      //  ||
      // selectedPatient?.patient_id;

      const response = await axios.post(
        'https://hmsapi.emedhatechnologies.com/master/api/api/verify-aadhar-otp',
        {
          otp: OTP,
          Aadhar_No,
          userId
        }
      );

      console.log(response.data);

      if (response.data.status === 'VALID') {

        setIsOtpVerified(true);
        setIsOtpSent(false);
        setError('');

        alert('Aadhaar Verified Successfully');

      } else {

        setError('OTP verification failed');
        alert('OTP verification failed');

      }

    } catch (error) {

      console.log(error);

      setError('Error verifying OTP');
      alert('Error verifying OTP');

    }
  };



  const [insuranceTypes, setInsuranceTypes] = useState([]);

  useEffect(() => {

    axios
      .get("https://hmsapi.emedhatechnologies.com/master/api/insurance-types")
      .then((res) => {
        setInsuranceTypes(res.data);
      });

  }, []);

  const showPrivateInsuranceFields =
    formData.insurance_type === "Private Cashless Insurance";

  return (

    <div className="registration-container fade-in" id="print-area">
      {(screenAction === "edit" || screenAction === "view") && (

        <div className="patient-search">

          <label>Search Patient</label>

          <input
            type="text"
            value={searchText}
            placeholder="Search by Name / ID / Mobile"
            onChange={(e) => searchPatients(e.target.value)}
          />

          {showDropdown && patients.length > 0 && (

            <div className="patient-dropdown">

              {patients.map((p) => (
                <div
                  key={p.patient_id}
                  className="patient-item"
                  onClick={() => selectPatient(p)}
                >

                  {p.name} | {p.patient_id} | {p.mobile}

                </div>
              ))}

            </div>

          )}

        </div>

      )}

      {screenAction === "view" && formData.patient_id && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', marginTop: '10px' }}>
          <button
            type="button"
            onClick={() => alert(`Share Patient details (${formData.patient_id}) via WhatsApp!`)}
            style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#25D366', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(37, 211, 102, 0.3)', height: '36px' }}
            title="Share via WhatsApp"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
            </svg>
            WhatsApp
          </button>
        </div>
      )}


      <form className="luxury-form" >

        {/* BASIC DETAILS */}

        {/* BASIC DETAILS */}
        <div className="form-section-header">
          <h3>Basic Patient Details</h3>
        </div>

        {/* ROW 1: Patient ID, Full Name, Gender, DOB, Age (All in one line on large screens) */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

          <div className="input-box read-only" style={{ flex: '1 1 120px' }}>
            <label>Patient ID</label>
            <input type="text" name="patient_id" value={formData.patient_id || ""} readOnly />
          </div>

          <div className="input-box" style={{ flex: '2 1 200px' }}>
            <label>Full Name</label>
            <input type="text" name="name" onChange={handleChange} required value={formData.name || ""} disabled={isDisabled} />
          </div>

          <div className="input-box" style={{ flex: '0.8 1 100px' }}>
            <label>Gender</label>
            <select name="gender" onChange={handleChange} required value={formData.gender || ""} disabled={isDisabled}>
              <option value="">Select</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>

          <div className="input-box" style={{ flex: '1 1 130px' }}>
            <label>Date of Birth</label>
            <input type="date" name="dob" onChange={handleChange} value={formData.dob || ""} disabled={isDisabled} />
          </div>

          <div className="input-box" style={{ flex: '0.5 1 70px' }}>
            <label>Age</label>
            <input type="number" name="age" onChange={handleChange} value={formData.age || ""} disabled={isDisabled} />
          </div>

        </div>

        {/* ROW 2: Blood Group & Marital Status (Reduced widths) */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

          {/* Changed flex-grow to 0, and base width to 150px */}
          <div className="input-box" style={{ flex: '0 1 150px' }}>
            <label>Blood Group</label>
            <select name="blood_group" onChange={handleChange} value={formData.blood_group || ""} disabled={isDisabled}>
              <option value="">Select</option>
              <option>A+</option>
              <option>B+</option>
              <option>O+</option>
              <option>AB+</option>
              <option>A-</option>
              <option>B-</option>
              <option>O-</option>
              <option>AB-</option>
            </select>
          </div>

          {/* Changed flex-grow to 0, and base width to 150px */}
          <div className="input-box" style={{ flex: '0 1 150px' }}>
            <label>Marital Status</label>
            <select name="marital_status" onChange={handleChange} value={formData.marital_status || ""} disabled={isDisabled}>
              <option value="">Select</option>
              <option>Single</option>
              <option>Married</option>
              <option>Divorced</option>
            </select>
          </div>

        </div>

        {/* CONTACT INFORMATION */}

        {/* CONTACT INFORMATION */}
        <div className="form-section-header">
          <h3>Contact Information</h3>
        </div>

        {/* ROW 1: Mobile, WhatsApp, OTP, Email */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px', alignItems: 'flex-end' }}>

          <div className="input-box" style={{ flex: '1.5 1 180px' }}>
            <label>Mobile Number</label>
            <input type="tel" name="mobile" onChange={handleChange} value={formData.mobile || ""} disabled={isDisabled} />
          </div>

         

          <div className="input-box" style={{ flex: '2 1 250px' }}>
            <label>Email</label>
            <input type="email" name="email" onChange={handleChange} value={formData.email || ""} disabled={isDisabled} />
          </div>

        </div>

        {/* ROW 2: Address, City, State, Pin Code */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>

          {/* Address takes up the most space (flex: 3), height reduced to match inputs */}
          <div className="input-box" style={{ flex: '3 1 250px' }}>
            <label>Address</label>
            <textarea
              name="address"
              onChange={handleChange}
              value={formData.address || ""}
              disabled={isDisabled}
              rows="1"
              style={{ height: '42px', minHeight: '42px', padding: '10px' }}
            />
          </div>

          <div className="input-box" style={{ flex: '1 1 120px' }}>
            <label>City</label>
            <input type="text" name="city" onChange={handleChange} value={formData.city || ""} disabled={isDisabled} />
          </div>

          <div className="input-box" style={{ flex: '1 1 120px' }}>
            <label>State</label>
            {/* Default value set to Telangana if empty */}
            <input type="text" name="state" onChange={handleChange} value={formData.state || "Telangana"} disabled={isDisabled} />
          </div>

          <div className="input-box" style={{ flex: '1 1 100px' }}>
            <label>Pin Code</label>
            <input type="text" name="pincode" onChange={handleChange} value={formData.pincode || ""} disabled={isDisabled} />
          </div>

        </div>

        {/* IDENTIFICATION */}

        {/* IDENTIFICATION & EMERGENCY CONTACT */}
        <div className="form-section-header">
          <h3>Identification & Emergency Contact</h3>
        </div>

        {/* ROW: Govt ID, ID Number, Contact Name, Relationship, Emergency Phone */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

        
          <div className="input-box" style={{ flex: '1 1 130px' }}>
            <label>Government ID</label>

            <select
              name="govt_id_type"
              onChange={handleChange}
              value={formData.govt_id_type || ""}
              disabled={isDisabled}
            >
              <option value="">Select</option>
              <option>Aadhaar</option>
              <option>Passport</option>
              <option>Driving License</option>
            </select>
          </div>

          {/* ================= AADHAAR VERIFICATION ================= */}

          {formData.govt_id_type === "Aadhaar" ? (

            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: '10px',
                flexWrap: 'wrap',
                flex: '2 1 400px'
              }}
            >

              {!isOtpSent && !isOtpVerified && (
                <div className="input-box" style={{ flex: '1 1 180px' }}>
                  <label>Aadhaar Number</label>

                  <input
                    type="text"
                    name="Aadhar_No"
                    placeholder="Enter 12 Digit Aadhaar"
                    value={Aadhar_No}
                    onChange={handleInputChangev}
                    maxLength={12}
                    disabled={isDisabled}
                  />
                </div>
              )}

              {isOtpSent && !isOtpVerified && (
                <div className="input-box" style={{ flex: '1 1 120px' }}>
                  <label>Enter OTP</label>

                  <input
                    type="text"
                    name="OTP"
                    placeholder="Enter OTP"
                    value={OTP}
                    onChange={handleInputChangev}
                    disabled={isDisabled}
                  />
                </div>
              )}

              {/* SEND OTP BUTTON */}

              {!isOtpSent && !isOtpVerified && (
                <button
                  type="button"
                  onClick={sendOtp}
                  disabled={isDisabled}
                  style={{
                    padding: '10px 14px',
                    background: '#007bff',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    height: '42px'
                  }}
                >
                  Send OTP
                </button>
              )}

              {/* VERIFY BUTTON */}

              {isOtpSent && !isOtpVerified && (
                <button
                  type="button"
                  onClick={verifyOtp}
                  disabled={isDisabled}
                  style={{
                    padding: '10px 14px',
                    background: 'green',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    height: '42px'
                  }}
                >
                  Verify OTP
                </button>
              )}

              {/* VERIFIED */}

              {isOtpVerified && (
                <>
                  <div
                    style={{
                      color: 'green',
                      fontWeight: 'bold',
                      paddingBottom: '10px'
                    }}
                  >
                    ✓ Verified
                  </div>

             
                </>
              )}

              {error && (
                <div style={{ color: 'red', fontSize: '13px' }}>
                  {error}
                </div>
              )}

            </div>

          ) : (

            <div className="input-box" style={{ flex: '1.5 1 150px' }}>
              <label>ID Number</label>

              <input
                type="text"
                name="govt_id_number"
                onChange={handleChange}
                value={formData.govt_id_number || ""}
                disabled={isDisabled}
              />
            </div>

          )}
          <div className="input-box" style={{ flex: '1.5 1 150px' }}>
            <label>Contact Name</label>
            <input type="text" name="emergency_name" onChange={handleChange} value={formData.emergency_name || ""} disabled={isDisabled} />
          </div>

          <div className="input-box" style={{ flex: '1 1 120px' }}>
            <label>Relationship</label>
            <input type="text" name="emergency_relation" onChange={handleChange} value={formData.emergency_relation || ""} disabled={isDisabled} />
          </div>

          <div className="input-box" style={{ flex: '1.5 1 150px' }}>
            <label>Emergency Phone</label>
            <input type="tel" name="emergency_phone" onChange={handleChange} value={formData.emergency_phone || ""} disabled={isDisabled} />
          </div>

        </div>


        {/* MEDICAL */}

        {/* MEDICAL INFORMATION */}
        <div className="form-section-header">
          <h3>Medical Information</h3>
        </div>

        {/* ROW 1: All 4 Medical fields on one line */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

          <div className="input-box" style={{ flex: '1 1 180px' }}>
            <label>Known Allergies</label>
            <textarea
              name="allergies"
              onChange={handleChange}
              value={formData.allergies || ""}
              disabled={isDisabled}
              rows="2"
              style={{ overflowY: 'auto', resize: 'vertical' }}
            />
          </div>

          <div className="input-box" style={{ flex: '1 1 180px' }}>
            <label>Existing Conditions</label>
            <textarea
              name="conditions"
              onChange={handleChange}
              value={formData.conditions || ""}
              disabled={isDisabled}
              rows="2"
              style={{ overflowY: 'auto', resize: 'vertical' }}
            />
          </div>

          <div className="input-box" style={{ flex: '1 1 180px' }}>
            <label>Current Medications</label>
            <textarea
              name="medications"
              onChange={handleChange}
              value={formData.medications || ""}
              disabled={isDisabled}
              rows="2"
              style={{ overflowY: 'auto', resize: 'vertical' }}
            />
          </div>

          <div className="input-box" style={{ flex: '1 1 180px' }}>
            <label>Previous Medical History</label>
            <textarea
              name="medical_history"
              onChange={handleChange}
              value={formData.medical_history || ""}
              disabled={isDisabled}
              rows="2"
              style={{ overflowY: 'auto', resize: 'vertical' }}
            />
          </div>

        </div>

        {/* ROW 2: File Upload */}
        {/* ROW 2: File Upload (Reduced Width) */}
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

          {/* Changed flex to 0 1 300px so it only takes up necessary space */}
          <div className="input-box" style={{ flex: '0 1 280px' }}>
            <label>Upload Medical Records</label>
            <input
              type="file"
              name="medical_file"
              multiple
              onChange={handleFileChange}
              disabled={isDisabled}
            />
          </div>

        </div>

        {/* PREVIEW CONTAINER */}
        <div className="preview-container">
          {Array.isArray(medicalFiles) && medicalFiles.length > 0 ? (
            medicalFiles.map((item, index) => (
              <div key={index} className="preview-box">
                <img
                  src={item.preview}
                  alt="medical record"
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=File+Error'; }}
                />
                {!isDisabled && (
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => removeFile(index)}
                  >
                    ✕
                  </button>
                )}
              </div>
            ))
          ) : (
            <p style={{ fontSize: '12px', color: '#999', marginLeft: '10px' }}>No records uploaded.</p>
          )}
        </div>

        {/* INSURANCE */}

        <div className="form-section-header">
          <h3>Insurance Details</h3>
        </div>

        <div className="form-grid">

          <div className="input-box" >
            <label>Insurance Type</label>

           
            <select
              name="insurance_type"
              value={formData.insurance_type || ""}
              onChange={handleChange} disabled={isDisabled}
            >
              <option value="">Select Insurance Type</option>

              {insuranceTypes.map((item) => (

                <option
                  key={item.insurance_type_id}
                  value={item.insurance_type_name}
                >
                  {item.insurance_type_name}
                </option>

              ))}
            </select>


          </div>
          {showPrivateInsuranceFields && (
            <>
              <div className="input-box">
                <label>Insurance Company</label>
                <input type="text" name="insurance_provider" onChange={handleChange} value={formData.insurance_provider || ""} disabled={isDisabled} />
              </div>

              <div className="input-box">
                <label>Policy Number</label>
                <input type="text" name="policy_number" onChange={handleChange} value={formData.policy_number || ""} disabled={isDisabled} />
              </div>

              <div className="input-box">
                <label>Insurance Validity</label>
                <input type="date" name="insurance_validity" onChange={handleChange} value={formData.insurance_validity || ""} disabled={isDisabled} />
              </div>
              <div className="input-box">
                <label>Insurance Amount</label>

                <input
                  type="number"
                  name="insurance_amount"
                  onChange={handleChange}
                  value={formData.insurance_amount || ""}
                  disabled={isDisabled}
                />
              </div>

            </>
          )}

       


        </div>


     

        {/* ADMIN */}

        <div className="form-section-header">
          <h3>Administrative Details</h3>
        </div>

        <div className="form-grid">

          <div className="input-box">
            <label>Registration Date</label>
            <input type="date" name="registration_date" value={formData.registration_date || ""} disabled={isDisabled} />
          </div>

          <div className="input-box">
            <label>Registration Fee (Editable)</label>
            <input
              type="number"
              name="registration_fee"
              onChange={handleChange}
              value={formData.registration_fee || ""}
              disabled={isDisabled}
              placeholder="Auto-fills from Doctor"
            />
          </div>
          <div className="input-box">
            <label>Referred By</label>
            <input type="text" name="referred_by" onChange={handleChange} value={formData.referred_by || ""} disabled={isDisabled} />
          </div>

        </div>


      </form>
    </div>
  );
};

export default NewPatientRegistration;